/* Ammerländer Schinkendiele - Konfigurator Data */
window.KONFIG_PRODUCTS = 
[
  {
    "id": "luftgetrocknete-mettwurst-stuck-ca-600g",
    "name": "Luftgetrocknete Mettwurst,Stück ca. 600g",
    "price": 17.69,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Luftgetrocknete_Mettwurst_Nr_256_Schinkendiele.jpg?v=1731340870",
    "weight_g": 600,
    "volume_ml": 1080,
    "vegetarian": false,
    "vegan": false,
    "popularity": 17
  },
  {
    "id": "drogt-mettwurst-stuck-250g",
    "name": "»Drögt-Mettwurst« | Stück 250g",
    "price": 6.95,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/DroegtMettwrust_Nr_257_ee1d48a7-19d6-4057-a3c1-1d000029c0f6.jpg?v=1731340924",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 14
  },
  {
    "id": "nuss-schinken-gerauchert",
    "name": "Nuss-Schinken, geräuchert",
    "price": 28.38,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nuss_Schinken_Geraeuchert_Nr_107_Schinkendiele_19b39bbc-6bb4-4532-9f80-3af84ca4f257.jpg?v=1731340371",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 14
  },
  {
    "id": "nuss-schinken-luftgetrocknet",
    "name": "Nuss-Schinken, luftgetrocknet",
    "price": 26.96,
    "category": "Schinken",
    "tags": [
      "Luftgetrocknet",
      "Spargelzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_607_image_1.jpg?v=1731347037",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 13
  },
  {
    "id": "geraucherter-katenschinken",
    "name": "Geräucherter Katenschinken",
    "price": 8.56,
    "category": "Schinken",
    "tags": [
      "Geräuchert",
      "Spargelzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/119-Katenschinken-2021.jpg?v=1731352690",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 10
  },
  {
    "id": "ammerlander-schwarzbrot-500g",
    "name": "Ammerländer Schwarzbrot | 500g",
    "price": 3.2,
    "category": "Brot",
    "tags": [
      "Brot",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/449-SchwarzbrotrmLHwUxRA7JRz.jpg?v=1731350237",
    "weight_g": 500,
    "volume_ml": 1000,
    "vegetarian": true,
    "vegan": false,
    "popularity": 8
  },
  {
    "id": "die-kleine-sommermettwurst-stuck-350g",
    "name": "Die Kleine Sommermettwurst | Stück 350g",
    "price": 7.95,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Kleine_Sommermettwurst_Nr_241_Schinkendiele_fdbe2db2-bfdd-421c-8b66-dbb52b770a81.jpg?v=1731340757",
    "weight_g": 350,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 8
  },
  {
    "id": "fleur-de-sel-truffel-100g",
    "name": "Fleur de Sel-Trüffel 100g",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6533-Fleur-de-Sel-Truffel-1.jpg?v=1731351863",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 7
  },
  {
    "id": "akazienhonig",
    "name": "Akazienhonig",
    "price": 4.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6823.jpg?v=1731348306",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 7
  },
  {
    "id": "1-x-hausmacher-rotwurst-1-x-leberwurst-im-ring-je-ca-210g",
    "name": "1 x Hausmacher Rotwurst + 1 x Leberwurst im Ring, je ca. 230g",
    "price": 11.95,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Hausmacher_Rotwurst_Leberwurst_Im_Ring_Nr_360_361_Schinkendiele_ef69bf19-05db-43c7-915c-99c434909ee5.jpg?v=1731354531",
    "weight_g": 230,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 7
  },
  {
    "id": "hausmacher-mettwurst-gekocht-200g-dose",
    "name": "Hausmacher Mettwurst gekocht | 200g Dose",
    "price": 5.45,
    "category": "Mettwurst",
    "tags": [
      "Feinkost in Dosen",
      "Mettwurst"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/615.jpg?v=1731343682",
    "weight_g": 200,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 7
  },
  {
    "id": "hausmacher-leberwurst-im-ring-ca-210g",
    "name": "Hausmacher Leberwurst im Ring | ca. 230g",
    "price": 6.77,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Hausmacher_Rotwurst_Leberwurst_Im_Ring_Nr_360_361_Schinkendiele.jpg?v=1731342605",
    "weight_g": 230,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 7
  },
  {
    "id": "hausmacher-bauern-leberwurst-im-weckglas-200g",
    "name": "Hausmacher-Bauern-Leberwurst im Weckglas | 200g",
    "price": 5.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Bauern_Leberwurst_Nr_491_Schinkendiele_6e74619f-5e1d-4f90-ade1-c88cd458b3b3.jpg?v=1731343258",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 6
  },
  {
    "id": "goldnusse-bonbons",
    "name": "Goldnüsse-Bonbons",
    "price": 3.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Bonbons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_186_image_1.jpg?v=1731348619",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 6
  },
  {
    "id": "aalrauch-bauernmettwurst-stuck-ca-1-0kg",
    "name": "Aalrauch-Bauernmettwurst",
    "price": 26.18,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Aalrauch_Bauernmettwurst_Nr_255_Schinkendiele_2757796d-d06d-4d31-9e0c-c2d59c78bf8d.jpg?v=1731340845",
    "weight_g": null,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 6
  },
  {
    "id": "sommermettwurst-ia-cervelatwurst-halbe-stuck-ca-1kg",
    "name": "Sommermettwurst Ia,Cervelatwurst,halbe,Stück ca. 1kg",
    "price": 29.48,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Sommermettwurst_La_Cervelatwurst_Nr_235.jpg?v=1731340686",
    "weight_g": null,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 6
  },
  {
    "id": "grobe-leberwurst-hausgemacht-200g-dose",
    "name": "Grobe Leberwurst - Hausgemacht | 200g Dose",
    "price": 5.45,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/616.jpg?v=1731343708",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 5
  },
  {
    "id": "original-ammerlander-grunkohl-im-schlauch-ca-500g",
    "name": "Original Ammerländer Grünkohl im Schlauch ca. 500g",
    "price": 5.95,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Grünkohlzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Gruenkohl_414-5_d2dd3033-a565-41c6-9422-6645521b0e4d.jpg?v=1738925837",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 5
  },
  {
    "id": "truffelmischung-ohne-alkohol-100g-packung",
    "name": "Trüffelmischung ohne Alkohol 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6575-Truffelmischung-1.jpg?v=1731341793",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 5
  },
  {
    "id": "ostfriesische-teestunde-schwarztee",
    "name": "Ostfriesische Teestunde Schwarztee",
    "price": 2.8,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_313_image_1.jpg?v=1731353281",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 5
  },
  {
    "id": "ganseschmaus-im-glas-125g",
    "name": "Gänseschmaus im Glas | 125g",
    "price": 4.45,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich",
      "aus dem Ammerland"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/481-G-nseschmaus.jpg?v=1731343409",
    "weight_g": 125,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "pumpernickel-in-schmuckdose-250g",
    "name": "Pumpernickel in Schmuckdose | 250g",
    "price": 3.25,
    "category": "Feinkost in Dosen",
    "tags": [
      "Brot",
      "Feinkost in Dosen",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/455.jpg?v=1731343557",
    "weight_g": 250,
    "volume_ml": 375,
    "vegetarian": true,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "ammerlander-zuckerzwieback-150g-tute",
    "name": "Ammerländer Zuckerzwieback 150g Tüte",
    "price": 4.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ammerlaender_Zuckerzwieback_Nr_6700_Schinkendiele.jpg?v=1731341678",
    "weight_g": 150,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "kandissticks",
    "name": "Kandissticks",
    "price": 3.9,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6506-2.jpg?v=1738239408",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "bauern-fruhstucksmettwurst-im-weckglas-200g",
    "name": "Bauern Frühstücksmettwurst im Weckglas | 200g",
    "price": 5.95,
    "category": "Mettwurst",
    "tags": [
      "Eingekochtes",
      "Mettwurst"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Bauern_Fruehstuecksmettwurst_Nr_469_310bc232-631a-47c8-a7f6-b5548f2f0a5e.jpg?v=1731343109",
    "weight_g": 200,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "leckere-katenrauchwurst-am-stuck-1kg",
    "name": "Leckere Katenrauchwurst am Stück | 1kg",
    "price": 30.58,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Katenrauchwurst_Nr_269_Schinkendiele.jpg?v=1731341052",
    "weight_g": null,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "luftgetrocknete-hausmacher-mettwurst-stuck-ca-1kg",
    "name": "Luftgetrocknete Hausmacher Mettwurst | Stück ca. 900g",
    "price": 26.53,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Hausmacher_Mettwurst_Nr_260_Schinkendiele.jpg?v=1731340975",
    "weight_g": 900,
    "volume_ml": 1620,
    "vegetarian": false,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "bourbon-vanille-tee",
    "name": "Bourbon Vanille Tee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/5420-1.jpg?v=1738312041",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "harmonie-tee-aromatisierter-gruntee",
    "name": "Harmonie Tee, aromatisierter Grüntee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_348_image_1.jpg?v=1731344490",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 4
  },
  {
    "id": "feine-tomatenleberwurst-im-glas-180g",
    "name": "Feine Tomatenleberwurst im Glas | 180g",
    "price": 4.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/612-Tomatenleberwurst.jpg?v=1731343607",
    "weight_g": 180,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "ganse-leberwurst-160g-im-glas",
    "name": "Gänse-Leberwurst, 160g im Glas",
    "price": 5.45,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich",
      "Eingekochtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/628.jpg?v=1731353673",
    "weight_g": 160,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "schinkengriebenschmalz-im-beutel-ca-500g",
    "name": "Schinkengriebenschmalz, im Beutel ca. 500g",
    "price": 5.45,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Grünkohlzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/490-2.jpg?v=1738238217",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "rum-sahne-truffel-100g-packung-mit-alkohol",
    "name": "Rum-Sahne-Trüffel 100g Packung, mit Alkohol",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6552-Rum-Sahne-Truffel-1.jpg?v=1731354135",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "truffelmischung-mit-alkohol-100g-packung",
    "name": "Trüffelmischung mit Alkohol 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6576-Truffelmischung-mit1-2.jpg?v=1731341816",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "festtagskonfiture-extra-apfel-mit-zimt-und-vanille250g",
    "name": "Festtagskonfitüre extra Apfel mit Zimt und Vanille250g",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6809.jpg?v=1731351650",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "meine-himbeer-konfiture-250g",
    "name": "Meine Himbeer-Konfitüre, 250g",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6796.jpg?v=1731351459",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "rote-grutze",
    "name": "Rote Grütze",
    "price": 7.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6819_66873-1.jpg?v=1738239705",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "ammerlander-schinkendiele-mettwurst-im-ring-stuck-200g",
    "name": "Ammerländer Schinkendiele - Mettwurst im Ring | Stück 200g",
    "price": 5.95,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/252-Ammerl-im-Ring.jpg?v=1731340817",
    "weight_g": 200,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "luftgetrockneter-landschinken",
    "name": "Luftgetrockneter Landschinken aus der Ammerländer Schinkendiele",
    "price": 14.26,
    "category": "Schinken",
    "tags": [
      "Luftgetrocknet",
      "Spargelzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/122-Landschinken-2021.jpg?v=1731348943",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "golden-koppke-schwarztee",
    "name": "Golden Köppke Schwarztee",
    "price": 2.0,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_312_image_1.jpg?v=1731353303",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "hibiskusbluten",
    "name": "Hibiskusblüten",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6053.jpg?v=1731349522",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "ostfriesen-blatt-mischung-schwarztee",
    "name": "Ostfriesen Blatt-Mischung Schwarztee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_315_image_1.jpg?v=1731353258",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "ostfriesische-broken-mischung-schwarztee",
    "name": "Ostfriesische Broken Mischung Schwarztee",
    "price": 12.0,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_314_image_1.jpg?v=1731343825",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "rooibostee-vanille-sahne",
    "name": "Rooibostee Vanille-Sahne",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5949.jpg?v=1731345644",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "rote-grutze-fruchtetee",
    "name": "Rote Grütze Früchtetee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_457_image_1.jpg?v=1731346143",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 3
  },
  {
    "id": "feigensenf-200ml",
    "name": "Feigensenf 200ml",
    "price": 6.45,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich",
      "Käse/Milchprodukte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6860.jpg?v=1731352163",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "bauernschmaus-leberwurst-im-weckglas-200g",
    "name": "Bauernschmaus Leberwurst im Weckglas | 200g",
    "price": 5.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Bauernschmaus_Nr_474_Schinkendiele_6bebd5a6-0575-4ba7-8bc5-657916f9d003.jpg?v=1731343154",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "aromazucker-vanille-sahne-grob",
    "name": "Aromazucker Vanille-Sahne,grob",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Vanille-Sahne_Zucker_Nr_6640_Schinkendiele5964beac1a329.jpg?v=1731342509",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "chili-truffel-zartbitter",
    "name": "Chili - Trüffel Zartbitter",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6518-Chili-Truffel-1.jpg?v=1731351600",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "grummelkandis-250g-tute",
    "name": "Grümmelkandis,250g Tüte",
    "price": 1.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6513.jpg?v=1731342362",
    "weight_g": 250,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "ostfriesen-kluntje-500g",
    "name": "Ostfriesen Kluntje 500g",
    "price": 2.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ostf_Kluntje_Nr_6531_Schinkendiele_674be250-6c74-490e-a296-b960a8ecd6e1.jpg?v=1731352450",
    "weight_g": 500,
    "volume_ml": 1500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "vanille-sahne-truffel-100g-packung",
    "name": "Vanille-Sahne Trüffel, 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6573-Vanille-Sahne-Truffel-1.jpg?v=1731341768",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "zartbitter-schokolade-100g-packung",
    "name": "Zartbitter-Schokolade 100g Packung",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Schokolade"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Zartbitter_Schokolade_Nr_6587_Schinkendiele.jpg?v=1731342036",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "zartbitter-truffel-100g-packung",
    "name": "Zartbitter-Trüffel 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Zartbitter-Truffel-1.jpg?v=1731354014",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "manuka-honig-3er-set-3x-75gr",
    "name": "Manuka Honig - 3er Set",
    "price": 89.0,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/nzfyme-premium-manuka-honey-experience-set.jpg?v=1761231952",
    "weight_g": 225,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "meine-erdbeer-konfiture-250g-glas",
    "name": "Meine Erdbeer-Konfitüre, 250g Glas",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6800.jpg?v=1731341361",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "meine-erdbeere-rhabarber-konfiture-250g-glas",
    "name": "Meine Erdbeere & Rhabarber Konfitüre, 250g Glas",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6807.jpg?v=1731341442",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "eine-aalrauchmettwurst-fein-kugel-ca-250g",
    "name": "Eine Aalrauchmettwurst - fein | Kugel ca. 250g",
    "price": 6.45,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Aalrauchmettwurst_Fein_Grob_Nr_282_2835964886451187_afde9db3-5090-4813-8b83-badde845a089.jpg?v=1731341103",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "eine-aalrauchmettwurst-grob-kugel-ca-250g",
    "name": "Eine Aalrauchmettwurst - grob | Kugel ca. 250g",
    "price": 6.45,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_127_image_1.jpg?v=1731341129",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "luftgetrockneter-bauern-knochenschinken",
    "name": "Luftgetrockneter Bauern Knochenschinken",
    "price": 12.3,
    "category": "Schinken",
    "tags": [
      "Luftgetrocknet"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Luftgetrockneter_Bauern_Knochenschinken_Nr_145_146_147_Schinkendiele.jpg?v=1731352668",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "naturgereifter-gewurzschinken",
    "name": "Naturgereifter Gewürzschinken",
    "price": 10.0,
    "category": "Schinken",
    "tags": [
      "Luftgetrocknet"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Gewuerzschinken_Nr_123_125_Schinkendiele_bdce00e3-a63a-4026-bd3e-46171ecd9d38.jpg?v=1731348198",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "pi-lo-chun-gruntee",
    "name": "PI LO Chun Grüntee",
    "price": 8.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_329_image_1.jpg?v=1731344097",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "zwischenahner-teemischung-schwarztee",
    "name": "Zwischenahner Teemischung Schwarztee",
    "price": 2.8,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5050.jpg?v=1731343876",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "ammerlander-loffelschluck",
    "name": "Ammerländer Löffeltrunk (1 Fl. 0,7l ohne Löffel)",
    "price": 7.95,
    "category": "Wein & Spirituosen",
    "tags": [
      "Klare"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_216_image_1.jpg?v=1731348670",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "teelikor",
    "name": "Teelikör",
    "price": 8.95,
    "category": "Wein & Spirituosen",
    "tags": [
      "Liköre"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_218_image_1.jpg?v=1731348697",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 2
  },
  {
    "id": "leckere-kalbsleberwurst-im-glas-160g",
    "name": "Leckere Kalbsleberwurst im Glas | 160g",
    "price": 5.45,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/606-1.jpg?v=1738238701",
    "weight_g": 160,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "grunkohl-tafelfertig-mit-kasselerbauch-kochwurst-pinkel-1000g",
    "name": "Grünkohl, tafelfertig mit Kasselerbauch, Kochwurst & Pinkel | 1000g",
    "price": 14.8,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Grünkohlzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_417.jpg?v=1731350087",
    "weight_g": 1000,
    "volume_ml": 1500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "tomatensosse-sommertruffel-350ml",
    "name": "Tomatensoße-Sommertrüffel 350ml",
    "price": 5.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6875.jpg?v=1731352473",
    "weight_g": 350,
    "volume_ml": 525,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "die-echte-ammerlander-mockturtle-suppe",
    "name": "Die echte Ammerländer Mockturtle-Suppe",
    "price": 11.8,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/440.jpg?v=1731343506",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "roggenvollkornbrot-in-schmuckdose-500g",
    "name": "Roggenvollkornbrot in Schmuckdose | 500g",
    "price": 3.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Brot",
      "Feinkost in Dosen",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/456.jpg?v=1731343581",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": true,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "original-raucherlachs-aus-norwegen-300g-packung",
    "name": "Original Räucherlachs aus Norwegen",
    "price": 23.95,
    "category": "Fisch",
    "tags": [
      "Fisch"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_50_image_1.jpg?v=1731348892",
    "weight_g": null,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "original-raucherlachs-aus-norwegen-500g-packung",
    "name": "Original Räucherlachs aus Norwegen | 500g Packung",
    "price": 39.9,
    "category": "Fisch",
    "tags": [
      "Fisch"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_50_image_1_46863788-8f19-4e9c-bf97-8696419104e8.jpg?v=1731348916",
    "weight_g": 500,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "zwischenahner-raucheraal-stuck-ca-280g",
    "name": "Zwischenahner Räucheraal | Stück ca. 280g",
    "price": 21.82,
    "category": "Fisch",
    "tags": [
      "Fisch"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Zwischenahner_Raeucheral_Praesent_Nr_20.jpg?v=1731343435",
    "weight_g": 280,
    "volume_ml": 560,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "hafergrutze",
    "name": "Hafergrütze",
    "price": 1.95,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Grünkohlzeit",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/418.jpg?v=1731351744",
    "weight_g": null,
    "volume_ml": 600,
    "vegetarian": true,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "bad-zwischenahner-truffel",
    "name": "Bad Zwischenahner Trüffel 125g",
    "price": 7.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/truffel.jpg?v=1731349551",
    "weight_g": 125,
    "volume_ml": 375,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "butter-sahne-truffel-vm-die-traumhaften-75g-packung",
    "name": "Butter-Sahne Trüffel VM (Die Traumhaften) 75g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6582-Traumhaften-1.jpg?v=1731341938",
    "weight_g": 75,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "krustenkandis-braun-250g-tute",
    "name": "Krustenkandis braun,250g Tüte",
    "price": 1.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6510.jpg?v=1731342339",
    "weight_g": 250,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "schietwetter-bonbons",
    "name": "Schietwetter-Bonbons",
    "price": 3.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Bonbons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_184_image_1.jpg?v=1731348568",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "teezucker-kluntinchen",
    "name": "Teezucker »Kluntinchen«",
    "price": 1.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6525.jpg?v=1731342459",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "truffel-marc-de-champagne-100g-packung",
    "name": "Trüffel Marc de Champagne 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6583-Marc-de-Champagner-Truffel-1kE8r8J2ETZwBU.jpg?v=1731341964",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "vollmilch-truffel-100g-packung",
    "name": "Vollmilch-Trüffel 100g-Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6515-Vollmilch-Truffel-1.jpg?v=1731353897",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "weisser-kandis",
    "name": "Weisser Kandis",
    "price": 1.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_239_image_1.jpg?v=1731342435",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "friesische-sanddorn-konfiture-250g",
    "name": "Friesische Sanddorn-Konfitüre 250g",
    "price": 4.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4540.jpg?v=1731350603",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "meine-sauerkirsch-konfiture-250g-glas",
    "name": "Meine Sauerkirsch-Konfitüre, 250g Glas",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6801.jpg?v=1731341384",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "cheddar-kase-sartori-198g",
    "name": "Cheddar Käse Sartori 198g",
    "price": 6.95,
    "category": "Käse",
    "tags": [
      "Käse/Milchprodukte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/855-Chedda-K-se.png?v=1731353541",
    "weight_g": 198,
    "volume_ml": 400,
    "vegetarian": true,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "schinken-mettwurst-im-glas-160g",
    "name": "Schinken-Mettwurst im Glas | 160g",
    "price": 4.95,
    "category": "Mettwurst",
    "tags": [
      "Aufstrich",
      "Mettwurst"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/604-1.jpg?v=1738238672",
    "weight_g": 160,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "knoblauch-nudeln-500g",
    "name": "Knoblauch-Nudeln 500g",
    "price": 4.9,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_4003.jpg?v=1731351323",
    "weight_g": 500,
    "volume_ml": 1500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "ammerlander-kohlpinkel-4er-packung-ca-700g",
    "name": "Ammerländer Kohlpinkel - 4er Packung",
    "price": 12.16,
    "category": "Salami",
    "tags": [
      "Grünkohlzeit",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Kohlpinkel_487-1.jpg?v=1738239959",
    "weight_g": null,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "leckeres-kasseler-schaufele-kasseler-braten-ca-390g",
    "name": "Leckeres Kasseler Schäufele (Kasseler Braten) | ca. 370g",
    "price": 6.44,
    "category": "Salami",
    "tags": [
      "Grünkohlzeit",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/488-2.jpg?v=1738238160",
    "weight_g": 370,
    "volume_ml": 666,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "wattwurm-dat-original-9er-packung",
    "name": "Wattwurm - Dat Original 9er Packung",
    "price": 9.95,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Wattwurm_Dat_Original_Nr_208_Schinkendiele.jpg?v=1731349640",
    "weight_g": null,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "lachsschinken-stuck-ca-300g",
    "name": "Lachsschinken | Stück ca. 300g",
    "price": 8.18,
    "category": "Schinken",
    "tags": [
      "Luftgetrocknet"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/127-Lachsschinken-neu.jpg?v=1731340421",
    "weight_g": 300,
    "volume_ml": 800,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "edelstahlspange",
    "name": "Edelstahlspange",
    "price": 3.75,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Edelstahlspange_Nr_6601_Schinkendiele.jpg?v=1731346498",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "bad-zwischenahner-herzen-fruchtetee",
    "name": "Bad Zwischenahner Herzen Früchtetee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6126.jpg?v=1731346920",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "erdbeer-sahne-aromatisierter-schwarztee",
    "name": "Erdbeer-Sahne, aromatisierter Schwarztee",
    "price": 3.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_375_image_1.jpg?v=1731344868",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "gebrannte-mandeln-fruchtetee",
    "name": "Gebrannte Mandeln Früchtetee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6185.jpg?v=1731348391",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "kaminfeuer-tee",
    "name": "Kaminfeuer Tee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_459_image_1.jpg?v=1731346188",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "kleiner-drache-tee-aromatisierter-gruntee",
    "name": "Kleiner Drache Tee, aromatisierter Grüntee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_342_image_1.jpg?v=1731344396",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "knusperhauschen-tee",
    "name": "Knusperhäuschen Tee",
    "price": 5.9,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_460_image_1.jpg?v=1731346207",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "mokalbari-golden-assam-schwarztee",
    "name": "Mokalbari Golden Assam Schwarztee",
    "price": 9.5,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_656_image_1.jpg?v=1731347525",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "oma-frieda-s-apfelstrudel-tee-aromatisierter-schwarztee",
    "name": "Oma Frieda´s Apfelstrudel Tee, aromatisierter Schwarztee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_363_image_1.jpg?v=1731344712",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "ostfriesen-sonntagstee-schwarztee",
    "name": "Ostfriesen Sonntagstee Schwarztee",
    "price": 7.5,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_319_image_1.jpg?v=1731343902",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "rhabarber-sahne-aromatisierter-schwarztee",
    "name": "Rhabarber-Sahne, aromatisierter Schwarztee",
    "price": 3.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_360_image_1.jpg?v=1731344637",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "rooibostee-sahne-karamell",
    "name": "Rooibostee Sahne-Karamell",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_409_image_1.jpg?v=1731345488",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "roter-johann-fruchtetee",
    "name": "Roter Johann Früchtetee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_651_image_1.jpg?v=1731347472",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "schwarzer-sanddorn-tee-aromatisierter-schwarztee",
    "name": "Schwarzer Sanddorn Tee, aromatisierter Schwarztee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_365_image_1.jpg?v=1731344758",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "bischoffinger-grauer-burgunder-kabinett-trocken-0-75l",
    "name": "Bischoffinger Grauer Burgunder Kabinett trocken 0,75l",
    "price": 7.95,
    "category": "Wein & Spirituosen",
    "tags": [
      "Wein Deutsch"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/9135-Kabinett-trocken.jpg?v=1731351782",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "einen-zwischenahner-zinnloffel",
    "name": "Einen Zwischenahner Zinnlöffel",
    "price": 19.95,
    "category": "Wein & Spirituosen",
    "tags": [
      "Klare",
      "Zubehör"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/9050-Zinnloffel-neu.jpg?v=1731342193",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 1
  },
  {
    "id": "echter-deutscher-rapshonig",
    "name": "Echter deutscher Rapshonig",
    "price": 9.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich",
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6817.jpg?v=1731353379",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "feine-pate-im-glas-180g",
    "name": "Feine Pâtè im Glas | 180g",
    "price": 4.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/614-Feine-P-te.jpg?v=1731343656",
    "weight_g": 180,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "goldglanz-milder-vielblutenhonig",
    "name": "Goldglanz, milder Vielblütenhonig",
    "price": 6.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich",
      "Honig",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6815cjuqYhqbu8YoH.jpg?v=1731354291",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "grobe-pate-im-glas-180g",
    "name": "Grobe Pâtè im Glas | 180g",
    "price": 4.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/613-Grobe-P-te.jpg?v=1731343632",
    "weight_g": 180,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kalbfleischsulze-im-glas-160g",
    "name": "Kalbfleischsülze im Glas | 160g",
    "price": 5.45,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/608-2.jpg?v=1731349253",
    "weight_g": 160,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kraftfleisch-cornedbeef-im-glas-160g",
    "name": "Kraftfleisch Cornedbeef im Glas | 160g",
    "price": 5.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/607.jpg?v=1731349444",
    "weight_g": 160,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "leckere-spanferkelsulze-im-glas-160g",
    "name": "Leckere Spanferkelsülze im Glas | 160g",
    "price": 5.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/609.jpg?v=1731349279",
    "weight_g": 160,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rapshonig-fruhtracht",
    "name": "Rapshonig/Frühtracht",
    "price": 4.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich",
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Rapshonig-1.jpg?v=1738240056",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schinken-leberwurst-im-glas-160g",
    "name": "Schinken-Leberwurst im Glas | 160g",
    "price": 4.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/602.jpg?v=1731349179",
    "weight_g": 160,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schinken-sulzwurst-im-glas-160g",
    "name": "Schinken-Sülzwurst im Glas | 160g",
    "price": 4.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/603btkrxdfaW5hCV.jpg?v=1731349204",
    "weight_g": 160,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zwiebelleberwurst-im-glas-160g",
    "name": "Zwiebelleberwurst im Glas | 160g",
    "price": 4.95,
    "category": "Aufstrich",
    "tags": [
      "Aufstrich"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/605.jpg?v=1731349397",
    "weight_g": 160,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "delikatess-pumpernickel-das-leckere-schwarze-brot-250-g",
    "name": "Delikatess Pumpernickel – Das leckere schwarze Brot | 250 g",
    "price": 3.45,
    "category": "Brot",
    "tags": [
      "Brot",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/453-Pumpernickel_ad7ba0bb-bb93-4e44-8532-2912b2dc035e.jpg?v=1731350263",
    "weight_g": 250,
    "volume_ml": 600,
    "vegetarian": true,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "honig-schwarzbrot-500g",
    "name": "Honig-Schwarzbrot | 500g",
    "price": 3.9,
    "category": "Brot",
    "tags": [
      "Brot"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/406_Honig_Schwarzbrot-1.jpg?v=1738238017",
    "weight_g": 500,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-pfeffer-jagdwurst-im-weckglas-200g",
    "name": "Ammerländer Pfeffer-Jagdwurst im Weckglas | 200g",
    "price": 7.45,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Pfefferjagdwurst_Nr_495_Schinkendiele.jpg?v=1731343321",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bolognese-tomatensauce-nr-1",
    "name": "Bolognese-Tomatensauce Nr. 1",
    "price": 4.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6851.jpg?v=1731354311",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "brechbohnen-jung-und-fein-im-glas",
    "name": "Brechbohnen, jung und fein im Glas",
    "price": 2.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4051.jpg?v=1731352879",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "frische-hausmacher-schinkenrotwurst-im-weckglas-200g",
    "name": "Frische Hausmacher Schinkenrotwurst im Weckglas | 200g",
    "price": 5.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Schinkenwurst_Nr_478_Schinkendiele.jpg?v=1731343233",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "frisches-fruhstucksfleisch-in-gelee-200g-weckglas",
    "name": "Frisches Frühstücksfleisch in Gelee | 200g Weckglas",
    "price": 5.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Fruehstuecksfleisch_Nr_477_Schinkendiele.jpg?v=1731343205",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "herzhafte-bauernsulze-im-weckglas-200g",
    "name": "Herzhafte Bauernsülze im Weckglas | 200g",
    "price": 5.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Bauernsuelze_Nr_475_Schinkendiele.jpg?v=1731343180",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "junge-erbsen-karotten-im-glas",
    "name": "Junge Erbsen & Karotten im Glas",
    "price": 3.25,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4050.jpg?v=1731352857",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "sauerfleisch-in-aspik-500g-weckglas",
    "name": "Mildes Sauerfleisch in Aspik | 500g Weckglas",
    "price": 13.8,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/476.jpg?v=1731343085",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pizzaiola-mit-mediterranem-gemuse-tomatensauce-nr-3",
    "name": "Pizzaiola-mit mediterranem Gemüse, Tomatensauce Nr. 3",
    "price": 4.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Nudeln für Feinschmecker",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6852.jpg?v=1731354349",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "rosenkohl-im-glas",
    "name": "Rosenkohl im Glas",
    "price": 3.25,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4053.jpg?v=1731352904",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "schwarzwurzeln-im-glas",
    "name": "Schwarzwurzeln im Glas",
    "price": 2.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4054.jpg?v=1731352926",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "steinpilz-rahmsosse-350ml",
    "name": "Steinpilz-Rahmsoße 350ml",
    "price": 5.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6877.jpg?v=1731352498",
    "weight_g": 350,
    "volume_ml": 525,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "stollenwerk-kartoffeln-im-glas-tafelfertig-gekocht",
    "name": "Stollenwerk Kartoffeln im Glas - tafelfertig, gekocht",
    "price": 2.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Grünkohlzeit",
      "Spargelzeit",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/408.jpg?v=1731350165",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "tomatensauce-nr-6-sahne-peperoni-und-majoran",
    "name": "Tomatensauce Nr. 6- Sahne, Peperoni und Majoran",
    "price": 4.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6854.jpg?v=1731354330",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "tomatensosse-ricotta-rucola-350ml",
    "name": "Tomatensoße Ricotta-Rucola 350ml",
    "price": 5.95,
    "category": "Eingekochtes",
    "tags": [
      "Eingekochtes",
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6876.jpg?v=1731352520",
    "weight_g": 350,
    "volume_ml": 525,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "butterbrotsgurken-580ml",
    "name": "Butterbrotsgurken 580ml",
    "price": 6.45,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes",
      "Gurkengläser"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nr-6871.jpg?v=1731351983",
    "weight_g": 580,
    "volume_ml": 870,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "delikatess-gurken-580ml",
    "name": "Delikatess-Gurken 580ml",
    "price": 6.45,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes",
      "Gurkengläser"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nr-6883.jpg?v=1731352081",
    "weight_g": 580,
    "volume_ml": 870,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "eisbein-in-aspik-500g-im-weckglas",
    "name": "Eisbein in Aspik | 500g im Weckglas",
    "price": 12.8,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Eisbein_In_Aspik_Nr_467_Schinkendiele.jpg?v=1731342784",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gewurzgurken-580ml",
    "name": "Gewürzgurken 580ml",
    "price": 6.45,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes",
      "Gurkengläser"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nr-6881.jpg?v=1731352056",
    "weight_g": 580,
    "volume_ml": 870,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gurkensticks-580ml",
    "name": "Gurkensticks 580ml",
    "price": 6.45,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes",
      "Gurkengläser"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nr-6888.jpg?v=1731352009",
    "weight_g": 580,
    "volume_ml": 870,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pfeffer-gurken-580ml",
    "name": "Pfeffer - Gurken 580ml",
    "price": 6.45,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes",
      "Gurkengläser"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nr-6882.jpg?v=1731351957",
    "weight_g": 580,
    "volume_ml": 870,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schlemmergurken-580ml",
    "name": "Schlemmergurken 580ml",
    "price": 6.45,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes",
      "Gurkengläser"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nr-6880.jpg?v=1731352030",
    "weight_g": 580,
    "volume_ml": 870,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ein-weckglas-eisbein-in-eigenem-saft-200g",
    "name": "ein Weckglas Eisbein in eigenem Saft, 200g",
    "price": 7.45,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/427-428-Sauerfleisch-250g.jpg?v=1731342836",
    "weight_g": 200,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ein-weckglas-sauerfleisch-in-gelee-200g",
    "name": "ein Weckglas Sauerfleisch in Gelee, 200g",
    "price": 7.45,
    "category": "Eingelegtes",
    "tags": [
      "Eingelegtes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Sauerfleisch_Eisbein_Im_Eigenen_Saft_Nr_427_428_Schinkendiele5964b58d0baf4.jpg?v=1731342863",
    "weight_g": 200,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-erbseneintopf-800g-dose",
    "name": "Ammerländer Erbseneintopf | 800g Dose",
    "price": 8.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/438.jpg?v=1731343459",
    "weight_g": 800,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-huhnerfrikassee-500g-glas",
    "name": "Ammerländer Hühnerfrikassee | 500g Glas",
    "price": 14.8,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/792.jpg?v=1731342913",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bayrischer-wiesenochsenbraten",
    "name": "Bayrischer Wiesenochsenbraten",
    "price": 8.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/673.jpg?v=1731351840",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "delikate-gulaschsuppe-800g-dose",
    "name": "Delikate Gulaschsuppe | 800g Dose",
    "price": 12.8,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/439.jpg?v=1731343483",
    "weight_g": 800,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gilde-grunkohl-800g-dose",
    "name": "GILDE Grünkohl | 800g Dose",
    "price": 3.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen",
      "Grünkohlzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/416.jpg?v=1731350065",
    "weight_g": 800,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "grunkohlgericht-mit-pinkel-kassler-und-kochwurst-in-800g-dose",
    "name": "Grünkohlgericht mit Pinkel,Kassler und Kochwurst in 800g Dose",
    "price": 9.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen",
      "Grünkohlzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/415-1-2.jpg?v=1738238081",
    "weight_g": 800,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gulaschsuppe-400g",
    "name": "Gulaschsuppe 400g",
    "price": 6.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/646.jpg?v=1731350995",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hausmacher-bayrische-bierwurst-200g-dose",
    "name": "Hausmacher Bayrische Bierwurst | 200g Dose",
    "price": 5.45,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/618.jpg?v=1731343756",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hausmacher-rotwurst-200g-dose",
    "name": "Hausmacher Rotwurst | 200g Dose",
    "price": 5.45,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/655.jpg?v=1731349471",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hausmacher-sulzwurst-200g-dose",
    "name": "Hausmacher Sülzwurst | 200g Dose",
    "price": 5.45,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/617.jpg?v=1731343732",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hirschgulasch-400g",
    "name": "Hirschgulasch 400g",
    "price": 8.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/663.jpg?v=1731350925",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hirschkeule-in-feinster-rahmsauce-300g",
    "name": "Hirschkeule in feinster Rahmsauce 300g",
    "price": 15.8,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_644.jpg?v=1731350356",
    "weight_g": 300,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kartoffelsuppe-400g",
    "name": "Kartoffelsuppe 400g",
    "price": 5.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/683.jpg?v=1731350379",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kohlrouladen-in-pikanter-sauce-800g",
    "name": "Kohlrouladen in pikanter Sauce 800g",
    "price": 7.45,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/679.jpg?v=1731351132",
    "weight_g": 800,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "konigsberger-klopse-in-pikant-feiner-kapernsauce-400g",
    "name": "Königsberger Klopse in pikant-feiner Kapernsauce 400g",
    "price": 5.25,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_678.jpg?v=1731350511",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "labskaus-nach-altem-familenrezept-800g-dose",
    "name": "Labskaus nach altem Familenrezept | 800g Dose",
    "price": 11.8,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/480.jpg?v=1731343533",
    "weight_g": 800,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "leberknodelsuppe-400g",
    "name": "Leberknödelsuppe 400g",
    "price": 5.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/710.jpg?v=1731350902",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "linsensuppe-400g",
    "name": "Linsensuppe 400g",
    "price": 5.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/682.jpg?v=1731350423",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "mildessa-weinsauerkraut-810g",
    "name": "MILDESSA Weinsauerkraut | 810g",
    "price": 4.45,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/419.jpg?v=1731350136",
    "weight_g": 810,
    "volume_ml": 1215,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "maultaschensuppe-schwabische-art-400g",
    "name": "Maultaschensuppe -Schwäbische Art- 400g",
    "price": 5.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/685.jpg?v=1731350947",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "omas-hausmacher-sauerkraut-400g",
    "name": "Omas Hausmacher Sauerkraut 400g",
    "price": 4.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/680.jpg?v=1731351064",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "putengulasch-400g",
    "name": "Putengulasch 400g",
    "price": 6.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/672.jpg?v=1731350880",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rindergulasch-in-feinster-sauce-400g",
    "name": "Rindergulasch in feinster Sauce 400g",
    "price": 7.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/677.jpg?v=1731350488",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rinderroulade-in-feinster-sauce-400g",
    "name": "Rinderroulade in feinster Sauce 400g",
    "price": 8.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/676.jpg?v=1731350972",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rindfleischsuppe-pichelsteiner-art-400g",
    "name": "Rindfleischsuppe -Pichelsteiner Art- 400g",
    "price": 6.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/711.jpg?v=1731350536",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sauerbraten-in-fein-saurer-sosse-400g",
    "name": "Sauerbraten in fein-saurer Soße 400g",
    "price": 8.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/671.jpg?v=1731351087",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "tafelspitz-in-meerrettichsosse-400g",
    "name": "Tafelspitz in Meerrettichsoße 400g",
    "price": 8.95,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/674.jpg?v=1731351110",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "wildragout-in-waldpilzsauce-400g-dose",
    "name": "Wildragout in Waldpilzsauce  400g Dose",
    "price": 8.45,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/664.jpg?v=1731354196",
    "weight_g": 400,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "wildschweinkeule-in-feinster-rahmsauce-300g",
    "name": "Wildschweinkeule in feinster Rahmsauce 300g",
    "price": 15.8,
    "category": "Feinkost in Dosen",
    "tags": [
      "Feinkost in Dosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_645.jpg?v=1731350332",
    "weight_g": 300,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bratengulasch-nach-hausfrauenart-500g-im-weckglas",
    "name": "Bratengulasch nach Hausfrauenart | 500g im Weckglas",
    "price": 13.8,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Gebratenes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/468.jpg?v=1731342889",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "fetter-speck-stuck-ca-500g",
    "name": "Fetter Speck,Stück ca. 500g",
    "price": 6.49,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Grünkohlzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Fetter_Speck_Nr_486_Schinkendiele.jpg?v=1731343380",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "grunkohl-vegan-500g-im-schlauch-tafelfertig",
    "name": "Grünkohl -VEGAN 500g im Schlauch, tafelfertig",
    "price": 5.95,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Grünkohlzeit",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/FF8FC3CB-D14E-48F8-A878-B32C5F38A52E.jpg?v=1738072634",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "leckere-kohlrouladen-im-weckglas-500g",
    "name": "Leckere Kohlrouladen im Weckglas | 500g",
    "price": 13.8,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Gebratenes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/657.jpg?v=1731342987",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "leckerer-sonntagsbraten-im-weckglas-500g",
    "name": "Leckerer Sonntagsbraten im Weckglas | 500g",
    "price": 13.8,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Gebratenes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_269_image_1.jpg?v=1731343013",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rinderrouladen-im-weckglas-500g",
    "name": "Rinderrouladen im Weckglas | 500g",
    "price": 14.8,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Gebratenes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/611.jpg?v=1731342960",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sauerbraten-nach-hausfrauenart-im-weckglas-500g",
    "name": "Sauerbraten nach Hausfrauenart im Weckglas | 500g",
    "price": 13.8,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Gebratenes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/661.jpg?v=1731343060",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schinken-griebenschmalz-mit-apfeln-und-zwiebeln-150g-glas",
    "name": "Schinken-Griebenschmalz, mit Äpfeln und Zwiebeln, 150g Glas",
    "price": 3.95,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Grünkohlzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/420.jpg?v=1731347287",
    "weight_g": 150,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "snirtjebraten-im-weckglas-500g",
    "name": "Snirtjebraten im Weckglas | 500g",
    "price": 13.8,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Gebratenes"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/610.jpg?v=1731342940",
    "weight_g": 500,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "vegane-pinkel-3er-packung",
    "name": "Vegane Pinkel - 3er Packung",
    "price": 4.95,
    "category": "Gebratenes & Fleisch",
    "tags": [
      "Grünkohlzeit",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/0938149A-B545-46BC-88A7-962496A89A76.jpg?v=1738133447",
    "weight_g": null,
    "volume_ml": 600,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "bad-zwischenahner-moorkugeln",
    "name": "Bad Zwischenahner Moorkugeln",
    "price": 3.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Bonbons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_633_image_1.jpg?v=1731347213",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "blatterkrokant-truffel-100g-packung",
    "name": "Blätterkrokant-Trüffel 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6512-Blatterkrokant-Truffel-1.jpg?v=1731353744",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "brauner-wurfelkandis-250g-tute",
    "name": "Brauner Würfelkandis, 250g Tüte",
    "price": 1.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6520.jpg?v=1731342409",
    "weight_g": 250,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "butter-waffeln-150g-packung",
    "name": "Butter-Waffeln,150g Packung",
    "price": 4.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_176_image_1.jpg?v=1731341700",
    "weight_g": 150,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "cappuccino-truffel-mit-alkohol-100g-packung",
    "name": "Cappuccino-Trüffel mit Alkohol, 100g-Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6541-Cappucchino-Truffel-1.jpg?v=1731353936",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "caramel-truffel-100g-packung-mit-alkohol",
    "name": "Caramel-Trüffel 100g-Packung, mit Alkohol",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6549-Caramel-Truffel-1.jpg?v=1731353973",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "dinkelvollkornkekse-150g-packung",
    "name": "Dinkelvollkornkekse, 200g Packung",
    "price": 5.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_680_image_1.jpg?v=1731346381",
    "weight_g": 200,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "eierlikor-truffel-100g-packung",
    "name": "Eierlikör-Trüffel 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6577-Eierlikor-Truffel-1.jpg?v=1731341840",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "erdnuss-kekse-braunes-friesengeback-150g-packung",
    "name": "Erdnuss-Kekse - braunes Friesengebäck, 200g Packung",
    "price": 5.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Erdnusskekse_Nr_758_Schinkendiele.jpg?v=1731341743",
    "weight_g": 200,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "feinster-kandiskuchen-450g",
    "name": "Feinster Kandiskuchen 450g",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Feinster_Kandiskuchen_Nr_6711.jpg?v=1731341601",
    "weight_g": 450,
    "volume_ml": 1350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "grand-marnier-truffel-100g-packung-mit-alkohol",
    "name": "Grand-Marnier-Trüffel 100g-Packung, mit Alkohol",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6527-1.jpg?v=1738239646",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "haselnuss-praline-100g-packung",
    "name": "Haselnuss-Praliné 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6550-Haselnuss-Praline-1.jpg?v=1731354076",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "herren-whisky-truffel-100g-packung",
    "name": "Herren Whisky Trüffel 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6584-Herren-Whiskey-Truffel-1.jpg?v=1731341987",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "honigkuchen-fruhstuckskuchen-ca-350g",
    "name": "Honigkuchen (Frühstückskuchen) ca. 450g",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6710.jpg?v=1731341576",
    "weight_g": 450,
    "volume_ml": 1350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "husten-krauter-mischung",
    "name": "Husten-Kräuter-Mischung",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Bonbons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_181_image_1.jpg?v=1731348495",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ingwerkuchen-fur-geniesser-400g",
    "name": "Ingwerkuchen für Genießer | 500g",
    "price": 4.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ingwer_Kuchen_Nr_6714_Schinkendiele.jpg?v=1731341625",
    "weight_g": 500,
    "volume_ml": 1500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kernige-kekse-friesengeback-150g-packung",
    "name": "Kernige Kekse - Friesengebäck, 200g Packung",
    "price": 5.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Kernige_Kekse_Nr_761_Schinkendiele.jpg?v=1731346399",
    "weight_g": 200,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kir-royal-truffel-100g-packung",
    "name": "Kir-Royal-Trüffel 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6579-Kir-Royal-Truffel-1.jpg?v=1731341890",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kirschwasser-truffel-100g-packung-mit-alkohol",
    "name": "Kirschwasser-Trüffel 100g Packung, mit Alkohol",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6532-Kirschwasser-Truffel-1.jpg?v=1731354115",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "lompenzucker-a-la-perruche",
    "name": "Lompenzucker à la Perruche",
    "price": 1.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6516.jpg?v=1731342385",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "marzipanaal-100g-stuck",
    "name": "Marzipanaal 100g Stück",
    "price": 4.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Mazipanaal_Nr_742_Schinkendiele.jpg?v=1731341726",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "nussknusperchen-truffel-100g-packung",
    "name": "Nussknusperchen-Trüffel 100g-Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/nuss-truffel.jpg?v=1731353918",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "nusskuchen-de-luxe-ca-400g",
    "name": "Nusskuchen de Luxe ca. 450g",
    "price": 5.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nusskuchen_De_Luxe_Nr_6715_Schinkendiele.jpg?v=1731341650",
    "weight_g": 450,
    "volume_ml": 1350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rohrzucker-250g-tute",
    "name": "Rohrzucker,250g Tüte",
    "price": 1.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Rohrzucker_Nr_6535_Schinkendiele.jpg?v=1731342485",
    "weight_g": 250,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sahne-nougat-truffel-100g-packung",
    "name": "Sahne-Nougat-Trüffel 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Sahne-Nougat-Truffel-1.jpg?v=1731354055",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schokokekse-friesengeback-150g-packung",
    "name": "Schokokekse - Friesengebäck, 200g Packung",
    "price": 5.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Schokokekse_Nr_762_Schinkendiele.jpg?v=1731347090",
    "weight_g": 200,
    "volume_ml": 600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schwarzer-fadenkandis",
    "name": "Schwarzer Fadenkandis",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6503-1.jpg?v=1738239003",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "suchtigmacher-friesenkracker-150g",
    "name": "Süchtigmacher, Friesenkräcker 150g",
    "price": 4.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Gebäck - Kuchen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/780-1.jpg?v=1738238722",
    "weight_g": 150,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "vollmilch-schokolade-35-kakao-100g-packung",
    "name": "Vollmilch-Schokolade 35%Kakao 100g Packung",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Schokolade"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Vollmilch_Schokoladen_Nr_6586_Schinkendiele.jpg?v=1731342012",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "vollmilch-schokolade-mit-nussen-100g",
    "name": "Vollmilch-Schokolade mit Nüssen 100g",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Schokolade"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Vollmilch_Nuesse-1.jpg?v=1738240730",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "weisse-schokolade-36-kakao-100g-packung",
    "name": "Weiße Schokolade 36%Kakao 100g Packung",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Schokolade"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Weisse_Schokolade_Nr_6591_Schinkendiele.jpg?v=1731342086",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "eine-tute-weisser-fadenkandis",
    "name": "Weißer Fadenkandis",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Zucker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6500-1.jpg?v=1738238838",
    "weight_g": null,
    "volume_ml": 450,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "williams-birne-truffel-100g-packung",
    "name": "Williams-Birne Trüffel 100g Packung",
    "price": 7.45,
    "category": "Gebäck & Süßes",
    "tags": [
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6578-Williams-Birne-Truffel-1.jpg?v=1731341866",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zartbitter-schokolade-70-kakao-100g-packung",
    "name": "Zartbitter-Schokolade 70%Kakao 100g Packung",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Schokolade"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Zartbitter_Schokolade_70_Prozent_Nr_6588_Schinkendiele_3c99a66c-0b29-4678-87b3-ec3c6d1cceba.jpg?v=1731342062",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zartbitterschokolade-mit-nussen-100g",
    "name": "Zartbitterschokolade mit Nüssen 100g",
    "price": 3.95,
    "category": "Gebäck & Süßes",
    "tags": [
      "Schokolade"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6502-1.jpg?v=1738238882",
    "weight_g": 100,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bio-espresso-peru-ganze-bohne-250g",
    "name": "BIO-ESPRESSO-Peru, ganze Bohne 250g",
    "price": 12.8,
    "category": "Kaffee",
    "tags": [
      "Gebäck - Kuchen",
      "Kaffee",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/7214.jpg?v=1731354368",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "bio-kaffee-peru-gemahlen-250g",
    "name": "BIO-KAFFEE-Peru, gemahlen 250g",
    "price": 12.8,
    "category": "Kaffee",
    "tags": [
      "Gebäck - Kuchen",
      "Kaffee",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/7215.jpg?v=1731354390",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "espresso-roma-ganze-bohnen-250g",
    "name": "ESPRESSO--Roma, ganze Bohnen, 250g",
    "price": 10.8,
    "category": "Kaffee",
    "tags": [
      "Gebäck - Kuchen",
      "Kaffee",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/7218.jpg?v=1731354411",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "espresso-il-gustoso-ganze-bohnen-250g",
    "name": "ESPRESSO-Il Gustoso, ganze Bohnen, 250g",
    "price": 11.8,
    "category": "Kaffee",
    "tags": [
      "Gebäck - Kuchen",
      "Kaffee",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/7218_e917d7a5-6c55-4dc3-af14-5622fede31f0.jpg?v=1731354518",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "kaffee-guatemala-ganze-bohnen-250g",
    "name": "KAFFEE-Guatemala, ganze Bohnen, 250g",
    "price": 11.8,
    "category": "Kaffee",
    "tags": [
      "Gebäck - Kuchen",
      "Kaffee",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/7217_cfbecda6-d40e-40aa-b635-c56f97c37861.jpg?v=1731354476",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "kaffee-guatemala-gemahlen-250g",
    "name": "KAFFEE-Guatemala, gemahlen, 250g",
    "price": 11.8,
    "category": "Kaffee",
    "tags": [
      "Gebäck - Kuchen",
      "Kaffee",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/7217.jpg?v=1731354453",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "kaffee-klassik-ganze-bohnen-250g",
    "name": "KAFFEE-Klassik, ganze Bohnen, 250g",
    "price": 10.8,
    "category": "Kaffee",
    "tags": [
      "Gebäck - Kuchen",
      "Kaffee",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/7213_796e8f4a-8da5-4e8f-b5e7-4f24e781fc69.jpg?v=1731354497",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "kaffee-klassik-gemahlen-250g",
    "name": "KAFFEE-Klassik, gemahlen, 250g",
    "price": 10.8,
    "category": "Kaffee",
    "tags": [
      "Gebäck - Kuchen",
      "Kaffee",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/7213.jpg?v=1731354432",
    "weight_g": 250,
    "volume_ml": 500,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "karamell-kaffee-truffel-100g-packung",
    "name": "Karamell-Kaffee-Trüffel 100g Packung",
    "price": 7.45,
    "category": "Kaffee",
    "tags": [
      "Kaffee",
      "Trüffel"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Karamell-Kaffee-Truffel-1.jpg?v=1731354035",
    "weight_g": 100,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "friesische-sanddorn-hagebutten-konfiture-225g",
    "name": "Friesische Sanddorn-Hagebutten Konfitüre 250g",
    "price": 4.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4538.jpg?v=1731354235",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "friesische-sanddorn-holunder-konfiture-250g",
    "name": "Friesische Sanddorn-Holunder Konfitüre 250g",
    "price": 4.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4541.jpg?v=1731350580",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "friesisches-sanddorn-gelee-250g",
    "name": "Friesisches Sanddorn-Gelee 250g",
    "price": 4.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4539.jpg?v=1731350558",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "heidehonig",
    "name": "Heidehonig",
    "price": 8.8,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6826.jpg?v=1731348353",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "honigbienen",
    "name": "Honigbienen",
    "price": 3.45,
    "category": "Konfitüren & Honig",
    "tags": [
      "Bonbons",
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/FullSizeRender_220008e9-ce91-461e-8429-3fe9909cc784.jpg?v=1752739686",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "honigheber-aus-holz",
    "name": "Honigheber aus Holz",
    "price": 3.45,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_144_image_1.jpg?v=1731341248",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "honigwabe-in-akazienhonig-350g",
    "name": "Honigwabe in Akazienhonig 350g",
    "price": 9.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6872.jpg?v=1731352431",
    "weight_g": 350,
    "volume_ml": 455,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kastanienhonig",
    "name": "Kastanienhonig",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6842.jpg?v=1731347761",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "landhonig-fest",
    "name": "Landhonig (fest)",
    "price": 6.8,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6822.jpg?v=1731348283",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "lavendelhonig",
    "name": "Lavendelhonig",
    "price": 9.8,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6843JXXO918S4kDyK.jpg?v=1731354156",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "lindenhonig",
    "name": "Lindenhonig",
    "price": 8.45,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6824.jpg?v=1731348331",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "manuka-honig-mgo300-umf11-250g",
    "name": "Manuka-Honig MGO300+ UMF11+ 250g",
    "price": 59.9,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6933-Manuka-Honig-300uRFW2ttlshAgZ.jpg?v=1731353437",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "manuka-honig-mgo500-umf15-250g",
    "name": "Manuka-Honig MGO500+ UMF15+ 250g",
    "price": 85.9,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6934-Manuka-Honig-500.jpg?v=1731353457",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "manuka-honig-mgo850-umf20-250g",
    "name": "Manuka-Honig MGO850+ UMF20+ 250g",
    "price": 129.9,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6935-Manuka-Honig-850.jpg?v=1731353475",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "mein-holundergelee-250g-glas",
    "name": "Mein Holundergelee, 250g Glas",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6812.jpg?v=1731341483",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "mein-quittengelee-250g-glas",
    "name": "Mein Quittengelee, 250g Glas",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6811.jpg?v=1731341522",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "meine-heidelbeer-konfiture-250g-glas",
    "name": "Meine Heidelbeer-Konfitüre, 250g Glas",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6797-1.jpg?v=1738239681",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "meine-holunderbeere-apfel-konfiture-250g",
    "name": "Meine Holunderbeere-Apfel Konfitüre, 250g",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6793-Holunderbeere-Apfel.jpg?v=1731351481",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "meine-orangen-marmelade-im-glas-250g",
    "name": "Meine Orangen-Marmelade im Glas | 250g",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6792-1.jpg?v=1738239664",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "meine-weinbergpfirsich-konfiture-250g",
    "name": "Meine Weinbergpfirsich-Konfitüre, 250g",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Konfitüren"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6808-Weinbergpfirsich.jpg?v=1731351515",
    "weight_g": 250,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "orangenblutenhonig",
    "name": "Orangenblütenhonig",
    "price": 4.65,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6821.jpg?v=1731348258",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pinienhonig-500g",
    "name": "Pinienhonig 500g",
    "price": 9.8,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6838.jpg?v=1731354177",
    "weight_g": 500,
    "volume_ml": 650,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sanddorn-in-blutenhonig",
    "name": "Sanddorn in Blütenhonig",
    "price": 5.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/SanddorninBluetenhonig-2.jpg?v=1738240164",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sommerblutenhonig",
    "name": "Sommerblütenhonig",
    "price": 4.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6837.jpg?v=1731341223",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sonnenblumenhonig",
    "name": "Sonnenblumenhonig",
    "price": 7.45,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6816.jpg?v=1731348218",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "waldhonig",
    "name": "Waldhonig",
    "price": 5.65,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6820.jpg?v=1731348237",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "walnusse-in-akazienhonig",
    "name": "Walnüsse in Akazienhonig",
    "price": 11.95,
    "category": "Konfitüren & Honig",
    "tags": [
      "Honig"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6845.jpg?v=1731347741",
    "weight_g": null,
    "volume_ml": 350,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "deutsche-fass-butter-ca-200g-stuck",
    "name": "Deutsche Fass-Butter ca. 200g Stück",
    "price": 3.91,
    "category": "Käse",
    "tags": [
      "Käse/Milchprodukte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/879.jpg?v=1731351885",
    "weight_g": 200,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kristall-gouda-holland-ca-280g",
    "name": "Gouda mit leichten Kristallsalzen| Feinster holländischer Käse, ca. 240g",
    "price": 8.95,
    "category": "Käse",
    "tags": [
      "Käse/Milchprodukte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/804-KristallgoudaroJ0ydR8vrmlR_aac3b464-3baa-48f5-956d-bf70ecdc0e55.jpg?v=1731351724",
    "weight_g": 240,
    "volume_ml": 400,
    "vegetarian": true,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "2-stuck-aalrauchmettwurst-fein-grob-kugeln-ca-500g",
    "name": "2 Stück Aalrauchmettwurst, fein+ grob, Kugeln ca. 500g",
    "price": 11.9,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Aalrauchmettwurst_Fein_Grob_Nr_282_2835964886451187_832e1b7d-d996-4fe8-99af-5abe10b26c66.jpg?v=1731353110",
    "weight_g": 500,
    "volume_ml": 900,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-schinkendielen-mettwurst-stuck-ca-400g",
    "name": "Ammerländer Schinkendielen Mettwurst | Stück ca. 400g",
    "price": 10.92,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ammerlaender_Schinkendielenmettwurst_Nr_249_Schinkendiele.jpg?v=1731346833",
    "weight_g": 400,
    "volume_ml": 720,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bauern-stracke-mettwurst-stuck-ca-500g",
    "name": "Bauern-Stracke Mettwurst,Stück ca. 350g",
    "price": 16.86,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Bauern_Stracke_Mettwurst_Nr_234.jpg?v=1731339121",
    "weight_g": 350,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bauernhaus-mettwurst-stuck-ca-360g",
    "name": "Bauernhaus-Mettwurst, Stück ca. 380g",
    "price": 9.95,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Bauernhausmettwurst_Nr_294_Schinkendiele.jpg?v=1731349908",
    "weight_g": 380,
    "volume_ml": 684,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hausgemachte-rotwurst-im-ring-stuck-ca-280g",
    "name": "Hausgemachte Rotwurst im Ring | Stück ca. 230g",
    "price": 6.77,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_252_image_1.jpg?v=1731342632",
    "weight_g": 230,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "jubilaumsmettwurst-stuck-ca-580g",
    "name": "Jubiläumsmettwurst | Stück ca. 580g",
    "price": 17.09,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Jubilaeumssalami_Nr_240.jpg?v=1731340732",
    "weight_g": 580,
    "volume_ml": 1044,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "lange-durre-mettwurst-stuck-ca-500g",
    "name": "Lange dürre Mettwurst | Stück ca. 500g",
    "price": 16.39,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Lange_Duerre_Mettwurst_Nr_263_Schinkendiele.jpg?v=1731341000",
    "weight_g": 500,
    "volume_ml": 900,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "luftgetrocknete-bauernstange-400g",
    "name": "Luftgetrocknete Bauernstange | 370g",
    "price": 9.69,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/266-Bauernstange-1.jpg?v=1731341027",
    "weight_g": 370,
    "volume_ml": 666,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "luftgetrocknete-deelenmettwurst-ca-500g-stuck",
    "name": "Luftgetrocknete Deelenmettwurst | ca. 500g Stück",
    "price": 16.39,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Deelenmettwurst_Nr_236_Schinkendiele.jpg?v=1731346994",
    "weight_g": 500,
    "volume_ml": 900,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "luftgetrocknete-landmettwurst-ca-450g-stuck",
    "name": "Luftgetrocknete Landmettwurst | ca. 400g Stück",
    "price": 14.26,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Luftgetrocknete_Landmettwurst_Nr_264_Schinkendiele.jpg?v=1731349693",
    "weight_g": 400,
    "volume_ml": 720,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "mini-feldkieker-stuck-ca-500g",
    "name": "Mini-Feldkieker, Stück ca. 400g",
    "price": 16.19,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/274-Mini-Feldkieker.jpg?v=1731351914",
    "weight_g": 400,
    "volume_ml": 720,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pfeffermettwurst-pfeffer-peitsche-ca-400g-stuck",
    "name": "Pfeffermettwurst \"Pfeffer Peitsche\"",
    "price": 12.67,
    "category": "Mettwurst",
    "tags": [
      "Mettwurst",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Pfefferpeitsche_Nr_206_Schinkendiele.jpg?v=1731349614",
    "weight_g": null,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bandnudeln-4mm-250g",
    "name": "Bandnudeln 4mm 250g",
    "price": 2.9,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_4072.jpg?v=1731351157",
    "weight_g": 250,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "basilikum-nudeln-500g",
    "name": "Basilikum-Nudeln 500g",
    "price": 4.9,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_4075.jpg?v=1731351255",
    "weight_g": 500,
    "volume_ml": 1500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gabelspaghetti-250g",
    "name": "Gabelspaghetti 250g",
    "price": 2.9,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_4070.jpg?v=1731351278",
    "weight_g": 250,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kartoffel-nudeln-500g",
    "name": "Kartoffel-Nudeln 500g",
    "price": 4.9,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_4076.jpg?v=1731351300",
    "weight_g": 500,
    "volume_ml": 1500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "makkaroni-nudeln-500g",
    "name": "Makkaroni - Nudeln 500g",
    "price": 3.95,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_4073.jpg?v=1731351347",
    "weight_g": 500,
    "volume_ml": 1500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "nudelsosse-bella-crema-gewurz-100g",
    "name": "Nudelsoße Bella Crema Gewürz 100g",
    "price": 4.25,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6905-2.jpg?v=1738239807",
    "weight_g": 100,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "spaghetti-500g",
    "name": "Spaghetti 500g",
    "price": 4.9,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_4080.jpg?v=1731351370",
    "weight_g": 500,
    "volume_ml": 1500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "spiral-nudeln-250g",
    "name": "Spiral - Nudeln 250g",
    "price": 2.9,
    "category": "Nudeln",
    "tags": [
      "Nudeln für Feinschmecker"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_4078.jpg?v=1731351413",
    "weight_g": 250,
    "volume_ml": 750,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "aal-mettwurst-in-aalform-stuck-ca-400g",
    "name": "Aal-Mettwurst in AALFORM | Stück ca. 400g",
    "price": 12.95,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Aal_Mettwurst_In_Aalforn_Nr_285.jpg?v=1731341155",
    "weight_g": 400,
    "volume_ml": 720,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-spiessbraten-im-stuck-ca-600g",
    "name": "Ammerländer Spießbraten , im Stück ca. 600g",
    "price": 13.06,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ammerlaender_Spiessbraten_Nr_348_Schinkendiele.jpg?v=1731342579",
    "weight_g": 600,
    "volume_ml": 1080,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bierknacker-snack-5er-packung",
    "name": "Bierknacker Snack - 5er Packung",
    "price": 9.75,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Bierknacker_Nr_288_Schinkendiele.jpg?v=1731341179",
    "weight_g": null,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "echte-feldkieker-stuck-ca-750g",
    "name": "Echte Feldkieker,Stück ca. 680g",
    "price": 34.5,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Echte_Feldkiefer_Nr_238_Schinkendiele.jpg?v=1731339171",
    "weight_g": 680,
    "volume_ml": 1224,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "echte-salami-nach-mailander-art-halbes-stuck-ca-800g",
    "name": "Echte Salami nach Mailänder Art | halbes Stück ca. 800g",
    "price": 32.39,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Echte_Salami__Nr_262_Schinkendiele.jpg?v=1731340949",
    "weight_g": 800,
    "volume_ml": 1440,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "italienische-salametti-1a-ca-130g",
    "name": "Italienische Salametti - 1A | ca. 130g",
    "price": 5.45,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/239-Salametti_AS.jpg?v=1731342809",
    "weight_g": 130,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "italienische-salametti-mit-fenchel-stuck-ca-130g",
    "name": "Italienische Salametti mit Fenchel Stück ca. 160g",
    "price": 6.7,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/salami-italienisch.jpg?v=1731352766",
    "weight_g": 160,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "knoblauch-knabbersalami-4er-packung-ca-150g",
    "name": "Knoblauch-Knabbersalami | 4er Packung ca. 150g",
    "price": 5.0,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/212neu.jpg?v=1731349934",
    "weight_g": 150,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "knofelhex-die-knoblauch-salami-ca-300g",
    "name": "Knofelhex - die Knoblauch-Salami | ca. 300g",
    "price": 8.84,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/217_Knoblauch88HNbJk7zX7Ns.jpg?v=1731349718",
    "weight_g": 300,
    "volume_ml": 540,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kummelringe-packung-mit-5-stuck-ca-450g",
    "name": "Kümmelringe, Packung mit 5 Stück ca. 450g",
    "price": 11.78,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Kummelringe_Nr_227_Schinkendiele.jpg?v=1731340643",
    "weight_g": 450,
    "volume_ml": 810,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "leckere-kutschersalami-stuck-ca-240g",
    "name": "Leckere Kutschersalami | Stück ca. 240g",
    "price": 7.95,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Kutscherwurst_Nr_273_Schinkendiele.jpg?v=1731341077",
    "weight_g": 240,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "leckere-kummelsalami-ca-220g",
    "name": "Leckere Kümmelsalami | ca. 220g",
    "price": 5.95,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Kuemmelsalami_Nr_278_Schinkendiele.jpg?v=1731349962",
    "weight_g": 220,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "leckere-walnuss-salami-ca-380g",
    "name": "Leckere Walnuss-Salami | ca. 380g",
    "price": 16.8,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Walnusssalami_Nr_226_Schinkendiele.jpg?v=1731349988",
    "weight_g": 380,
    "volume_ml": 684,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "leckeres-grunkohl-fur-zwei-nr-89",
    "name": "Leckeres Grünkohl für Zwei | Nr. 89",
    "price": 34.0,
    "category": "Salami",
    "tags": [
      "Grünkohlzeit",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/89-1.jpg?v=1738237685",
    "weight_g": 1000,
    "volume_ml": 1800,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rauchenden-im-naturdarm-4er-packung",
    "name": "Rauchenden / Kochmettwurst im Naturdarm | 4er Packung",
    "price": 7.02,
    "category": "Salami",
    "tags": [
      "Grünkohlzeit",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Rauchenden_489-1.jpg?v=1738240118",
    "weight_g": null,
    "volume_ml": 630,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schinkenwurstchen-10er-pack-ca-500g",
    "name": "Schinkenwürstchen 10er Pack | ca. 500g",
    "price": 11.5,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Schinkenwurstchen_Nr_307_Schinkendiele.jpg?v=1731346425",
    "weight_g": 500,
    "volume_ml": 900,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "susser-hausmacher-senf-200-ml",
    "name": "Süßer Hausmacher-Senf | 200 ml",
    "price": 4.45,
    "category": "Salami",
    "tags": [
      "Aufstrich",
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/412.jpg?v=1731350212",
    "weight_g": 200,
    "volume_ml": 500,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "truthahn-cervelatwurst-fein-stuck-ca-800g",
    "name": "Truthahn-Cervelatwurst fein, Stück ca. 800g",
    "price": 26.22,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Truthahncervelat_Fein_Nr_224_Schinkendiele.jpg?v=1731340617",
    "weight_g": 800,
    "volume_ml": 1440,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zwischenahner-edelschimmelsalami-ca-350g",
    "name": "Zwischenahner Edelschimmelsalami, ca. 330g",
    "price": 10.81,
    "category": "Salami",
    "tags": [
      "Salami"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/221.jpg?v=1731340894",
    "weight_g": 330,
    "volume_ml": 594,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "geraucherter-bauchspeck-ideal-zum-grunkohl-ca-500g",
    "name": "Geräucherter Bauchspeck - Ideal zum Grünkohl | ca. 500g",
    "price": 9.79,
    "category": "Schinken",
    "tags": [
      "Geräuchert",
      "Grünkohlzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/484--_Bauchspeck_-_Shop.png?v=1738168158",
    "weight_g": 500,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "geraucherter-bauernknochenschinken",
    "name": "Geräucherter Bauernknochenschinken",
    "price": 12.3,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Geraeucherter_Bauern_Knochenschinken_Nr_142_140_Schinkendiele.jpg?v=1731352645",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "geraucherter-knochenschinken-das-beste-spiekerschinken",
    "name": "Geräucherter Knochenschinken »Das Beste« - Spiekerschinken",
    "price": 14.31,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_90_image_1.jpg?v=1731340464",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "knochenschinken-gewurfelt-ca-250g-packung",
    "name": "Knochenschinken - gewürfelt, ca. 250g-Packung",
    "price": 5.17,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Knochenschinken_Gewuerfelt_Nr_129_Schinkendiele.jpg?v=1731340544",
    "weight_g": 250,
    "volume_ml": 800,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "luftgetrockneter-knochenschinken-kaiserschinken",
    "name": "Luftgetrockneter Knochenschinken »Kaiserschinken«",
    "price": 14.31,
    "category": "Schinken",
    "tags": [
      "Luftgetrocknet"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Luftgetrockneter_Knochenschinken_Kaiserschinken_Nr_113_Schinkendiele.jpg?v=1731340491",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "moorschinken-stuck-ca-1-0kg",
    "name": "Moorschinken,Stück ca. 1,0kg",
    "price": 25.08,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Moorschinken_Nr_343_Schinkendiele.jpg?v=1731342555",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pro-domo-schinken-der-hit-fur-die-schlanke-linie",
    "name": "Pro Domo Schinken - „Der Hit für die schlanke Linie.“",
    "price": 11.44,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Pro_Modoro_Schinken_Nr_134_166_Schinkendiele.jpg?v=1731340565",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schinken-abschnitte-ca-500g-packung",
    "name": "Schinken-Abschnitte,ca. 500g-Packung",
    "price": 8.14,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Schinken_Abschnitte_Nr_128_Schinkendiele.jpg?v=1731340518",
    "weight_g": 500,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schumachers-kaminrauchschinken",
    "name": "Schumachers Kaminrauchschinken",
    "price": 10.0,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Schumachers_Kaminrauchschinken_Nr_137_161_Schinkendiele.jpg?v=1731340592",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schumachers-landrauchschinken",
    "name": "Schumachers Landrauchschinken",
    "price": 7.71,
    "category": "Schinken",
    "tags": [
      "Geräuchert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/101-103-Landrauchschinken-2021.jpg?v=1731348172",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zarter-aalrauchschinken-naturgereift-pape",
    "name": "Zarter Aalrauchschinken, naturgereift - Pape",
    "price": 11.44,
    "category": "Schinken",
    "tags": [
      "Geräuchert",
      "Spargelzeit"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_505_image_1.jpg?v=1731347117",
    "weight_g": null,
    "volume_ml": 1000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "apfel-essig",
    "name": "Apfel & Essig",
    "price": 7.95,
    "category": "Senf & Saucen",
    "tags": [
      "Essig & Oel",
      "Essig & Oel79",
      "Vegane Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/702.jpg?v=1731353879",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "arbequina-natives-olivenol-extra",
    "name": "Arbequina-Natives Olivenöl Extra",
    "price": 19.8,
    "category": "Senf & Saucen",
    "tags": [
      "Essig & Oel",
      "Essig & Oel79",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4013-Olivenol1.jpg?v=1731354255",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "erdbeer-essig",
    "name": "Erdbeer & Essig",
    "price": 7.95,
    "category": "Senf & Saucen",
    "tags": [
      "Essig & Oel",
      "Essig & Oel79",
      "Vegane Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/763.jpg?v=1731353821",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "fisch-fond-200ml",
    "name": "Fisch-Fond 200ml",
    "price": 4.45,
    "category": "Senf & Saucen",
    "tags": [
      "Delikatess Fonds"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_425.jpg?v=1731350804",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gemuse-fond-200ml",
    "name": "Gemüse-Fond 200ml",
    "price": 4.45,
    "category": "Senf & Saucen",
    "tags": [
      "Delikatess Fonds"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_432.jpg?v=1731350757",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "huhner-fond-200ml",
    "name": "Hühner - Fond 200ml",
    "price": 4.45,
    "category": "Senf & Saucen",
    "tags": [
      "Delikatess Fonds"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_437.jpg?v=1731350650",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "johannisbeer-essig",
    "name": "Johannisbeer & Essig",
    "price": 7.95,
    "category": "Senf & Saucen",
    "tags": [
      "Essig & Oel",
      "Essig & Oel79",
      "Vegane Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/770.jpg?v=1731353860",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "kalbs-fond-200ml",
    "name": "Kalbs-Fond 200ml",
    "price": 4.45,
    "category": "Senf & Saucen",
    "tags": [
      "Delikatess Fonds"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_443.jpg?v=1731350781",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kirsch-essig",
    "name": "Kirsch & Essig",
    "price": 7.95,
    "category": "Senf & Saucen",
    "tags": [
      "Essig & Oel",
      "Essig & Oel79",
      "Vegane Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/774-Kirsch-Essig-1.jpg?v=1731353841",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "mainova-classico-kaltgepresstes-olivenol",
    "name": "Mainova Classico-kaltgepresstes Olivenöl",
    "price": 11.8,
    "category": "Senf & Saucen",
    "tags": [
      "Essig & Oel",
      "Essig & Oel79",
      "Vegane Produkte",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/4014-Olivenol-1.jpg?v=1731354273",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": true,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "orange-essig",
    "name": "Orange & Essig",
    "price": 7.95,
    "category": "Senf & Saucen",
    "tags": [
      "Essig & Oel",
      "Essig & Oel79",
      "Vegane Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/771.jpg?v=1731353784",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "rinder-fond-200ml",
    "name": "Rinder-Fond 200ml",
    "price": 4.45,
    "category": "Senf & Saucen",
    "tags": [
      "Delikatess Fonds"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_445.jpg?v=1731350628",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "wild-fond-200ml",
    "name": "Wild-Fond 200ml",
    "price": 4.45,
    "category": "Senf & Saucen",
    "tags": [
      "Delikatess Fonds"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_423.jpg?v=1731350832",
    "weight_g": 200,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zitrone-essig",
    "name": "Zitrone & Essig",
    "price": 7.95,
    "category": "Senf & Saucen",
    "tags": [
      "Essig & Oel",
      "Essig & Oel79",
      "Vegane Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/778.jpg?v=1731353765",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": true,
    "popularity": 0
  },
  {
    "id": "moorgeist-glaser-2er",
    "name": "1 x  Ostfriesisches Moorgeist-Glas 2cl",
    "price": 3.5,
    "category": "Sonstiges",
    "tags": [
      "Zubehör"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/9216ulS38WdH3fvTR.jpg?v=1731342261",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "brotzeitkorb-nr-1-herzhaft-mit-wurst-schinken",
    "name": "Brotzeitkorb Nr. 1 Herzhaft mit Wurst + Schinken",
    "price": 57.0,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Praesentkorb_Nr_1_Schinkendiele.jpg?v=1731339228",
    "weight_g": 1000,
    "volume_ml": 2000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "feinschmecker-korb-nr-2-wurst-schinken",
    "name": "Feinschmecker-Korb Nr. 2 Wurst + Schinken",
    "price": 60.0,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Praesentkorb_Nr_2_Schinkendiele.jpg?v=1731339258",
    "weight_g": 1000,
    "volume_ml": 2000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "fit-hoch-3-weisser-tee",
    "name": "Fit Hoch 3 - Weißer Tee",
    "price": 5.5,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6380.jpg?v=1731348969",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "grillbratwurst",
    "name": "Grillbratwurst",
    "price": 7.95,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/MG_9658-2.jpg?v=1745577625",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "guangxi-white-buds-weisser-tee",
    "name": "Guangxi White Buds - Weißer Tee",
    "price": 7.0,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Guangxi-White-Buds.jpg?v=1731349103",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hahnchenbruststeak-curry",
    "name": "Hähnchenbruststeaks Curry",
    "price": 11.8,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/MG_9697.jpg?v=1745576586",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "huhnersuppe-mit-eierstich-nach-omas-art-800g-dose",
    "name": "Hühnersuppe nach regionaler Art 800g-Dose",
    "price": 9.95,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/776_Huehnersuppe_Omas.jpg?v=1762528576",
    "weight_g": 800,
    "volume_ml": 1600,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "korb-bad-zwischenahn-nr-3-spezialitaten-mit-wurst-schinken",
    "name": "Korb Bad Zwischenahn Nr. 3 Spezialitäten mit Wurst + Schinken",
    "price": 82.0,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Praesentkorb_Nr_3_Schinkendiele.jpg?v=1731339283",
    "weight_g": 1000,
    "volume_ml": 2000,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "mao-feng-china-weisser-tee",
    "name": "MAO Feng - China - Weißer Tee",
    "price": 6.5,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_330_image_1.jpg?v=1731344121",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "matcha-premium-tee-jadegrun-mild-suss",
    "name": "Matcha Premium Tee – jadegrün, mild & süß",
    "price": 13.9,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/MatchaTee.jpg?v=1753094125",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "nackensteak-paprika",
    "name": "Nackensteak Paprika",
    "price": 10.8,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/MG_9680.jpg?v=1745577400",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "nackensteaks-krauterbutter",
    "name": "Nackensteaks Kräuterbutter",
    "price": 10.8,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/MG_9687.jpg?v=1745577014",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pai-mu-tan-tee-china-spezial-weisser-tee",
    "name": "Pai Mu Tan Tee - China - Spezial,Weißer Tee",
    "price": 7.0,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_332_image_1.jpg?v=1731344172",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "panforte-di-siena-weisser-tee",
    "name": "Panforte di Siena - Weißer Tee",
    "price": 5.0,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5283.jpg?v=1731349127",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pfirsich-holunderblute-weisser-tee",
    "name": "Pfirsich Holunderblüte - Weißer Tee",
    "price": 5.0,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6382.jpg?v=1731348995",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rinderhuftsteaks-pink-pepper",
    "name": "Rinderhüftsteaks Pink Pepper",
    "price": 9.95,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/MG_9685-2.jpg?v=1745578816",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "tee-ei-zange-mit-feder",
    "name": "Tee-Ei,Zange mit Feder",
    "price": 3.95,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Teeeier_Nr_6610_11_12_13_Schinkendiele.jpg?v=1731346547",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "teefilter-100-stuck-packung",
    "name": "Teefilter 100 Stück/Packung",
    "price": 3.95,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Teefilter_Nr_6600_Schinkendiele.jpg?v=1731346474",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "teenetz",
    "name": "Teenetz",
    "price": 2.45,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Teenetz_Nr_6634_35_36_Schinkendiele.jpg?v=1731346727",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "teetutenfilter",
    "name": "Teetütenfilter",
    "price": 3.45,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_692_image_1.jpg?v=1731346946",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "teeuhr-7-minuten",
    "name": "Teeuhr 7 Minuten",
    "price": 6.95,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "teeuhr-fur-3-minuten",
    "name": "Teeuhr für 3 Minuten",
    "price": 6.95,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_481_image_1.jpg?v=1731346637",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "teeuhr-fur-5-minuten",
    "name": "Teeuhr für 5 Minuten",
    "price": 6.95,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Teeuhr_Nr_6622_21_Schinkendiele.jpg?v=1731348030",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "tempel-der-gotter-weisser-tee-tute-100g",
    "name": "Tempel der Götter - Weißer Tee -Tüte 100g",
    "price": 6.5,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6388.jpg?v=1731349037",
    "weight_g": 100,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "tullensieb-ostfriesischer-teebesen",
    "name": "Tüllensieb (Ostfriesischer Teebesen)",
    "price": 3.95,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_475_image_1.jpg?v=1731346522",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "universal-teefilter",
    "name": "Universal Teefilter",
    "price": 15.0,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_480_image_1.jpg?v=1731346614",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "universal-teefilter-fur-teekannen",
    "name": "Universal Teefilter für Teekannen",
    "price": 14.8,
    "category": "Sonstiges",
    "tags": [
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_479_image_1.jpg?v=1731346590",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "weisser-engel-weisser-tee",
    "name": "Weißer Engel - Weißer Tee",
    "price": 5.0,
    "category": "Sonstiges",
    "tags": [],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6392.jpg?v=1731349078",
    "weight_g": null,
    "volume_ml": 400,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "7-grune-kostbarkeiten-aromatisierter-gruntee",
    "name": "7 grüne Kostbarkeiten, aromatisierter Grüntee",
    "price": 5.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6334.jpg?v=1731348442",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "adventstee-aromatisierter-schwarztee-saisontee",
    "name": "Adventstee, aromatisierter Schwarztee (Saisontee)",
    "price": 3.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5540.jpg?v=1731344975",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-fruhstuckstee-schwarztee",
    "name": "Ammerländer Frühstückstee Schwarztee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_657_image_1.jpg?v=1731347597",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-krautertee-naturlich",
    "name": "Ammerländer Kräutertee natürlich",
    "price": 3.8,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_640_image_1.jpg?v=1731347372",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-obstkorb-fruchtetee",
    "name": "Ammerländer Obstkorb Früchtetee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_454_image_1.jpg?v=1731346070",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ananas-ingwer-gruntee-aromatisierter-gruntee",
    "name": "Ananas Ingwer Grüntee, aromatisierter Grüntee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_355_image_1.jpg?v=1731344587",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "assam-golden-flowery-broken-orange-pekoe-schwarztee",
    "name": "Assam Golden Flowery Broken Orange Pekoe Schwarztee",
    "price": 5.9,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5040.jpg?v=1731343850",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ballast-weg-tee-krautertee",
    "name": "Ballast weg Tee, Kräutertee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/5828-Ballast-weg.jpg?v=1731345270",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bancha-tee-japan-gruntee",
    "name": "Bancha Tee - Japan Grüntee",
    "price": 6.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_331_image_1.jpg?v=1731344146",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "basischer-krautertee",
    "name": "Basischer Kräutertee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5847.jpg?v=1731345295",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bauchwohltee-krautertee",
    "name": "Bauchwohltee, Kräutertee mit Anis-Fenchel + Kümmel",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_643_image_1.jpg?v=1731347448",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "birne-himbeere",
    "name": "Birne-Himbeere",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6144.jpg?v=1731348467",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "brennesselblatter-geschnitten-krautertee-100g",
    "name": "Brennesselblätter (geschnitten) Kräutertee 100g",
    "price": 3.8,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_400_image_1.jpg?v=1731345345",
    "weight_g": 100,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "buttertruffel-schwarztee-aromatisierter-schwarztee",
    "name": "Buttertrüffel Schwarztee, aromatisierter Schwarztee",
    "price": 5.0,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_660_image_1.jpg?v=1731347641",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ceylon-hochland-gruntee",
    "name": "Ceylon Hochland Grüntee",
    "price": 5.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ceylon-GT.jpg?v=1731351180",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ceylon-op-entkoffeinierter-schwarztee",
    "name": "Ceylon OP - entkoffeinierter Schwarztee",
    "price": 8.0,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee entkoff."
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_328_image_1.jpg?v=1731344071",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "chai-tee-aromatisierter-schwarztee",
    "name": "Chai Tee, aromatisierter Schwarztee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_377_image_1.jpg?v=1731344914",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "chai-mit-vanilla-tee-aromatisierter-schwarztee",
    "name": "Chai mit Vanilla Tee, aromatisierter Schwarztee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5422.jpg?v=1731344688",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "cranberry-pfirsich-aromatisierter-schwarztee",
    "name": "Cranberry - Pfirsich, aromatisierter Schwarztee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_658_image_1.jpg?v=1731347620",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "cranberry-tee",
    "name": "Cranberry Tee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_455_image_1.jpg?v=1731346095",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "creamy-berry-aromatisierter-schwarztee",
    "name": "Creamy Berry, aromatisierter Schwarztee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/5460-Creamy-Berry.jpg?v=1731353344",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "darjeeling-badamtam-ftgfop-second-flush-schwarztee",
    "name": "Darjeeling Badamtam FTGFOP Second Flush Schwarztee",
    "price": 6.5,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_323_image_1.jpg?v=1731344003",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "darjeeling-first-flush-badamtam-schwarztee",
    "name": "Darjeeling First Flush (Badamtam) Schwarztee",
    "price": 8.0,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Darjeeling-First-Flush-min.jpg?v=1731343951",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "darjeeling-tigerhill-tgfop-schwarztee",
    "name": "Darjeeling Tigerhill TGFOP Schwarztee",
    "price": 7.5,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_322_image_1.jpg?v=1731343977",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "earl-grey-gruntee-aromatisierter-gruntee",
    "name": "Earl Grey Grüntee, aromatisierter Grüntee",
    "price": 5.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_347_image_1.jpg?v=1731344463",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "eierpunsch-aromatisierter-schwarztee",
    "name": "Eierpunsch, aromatisierter Schwarztee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_378_image_1.jpg?v=1731344938",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "erdbeer-aprikose-fruhlingsbluten-aromatisierter-gruntee",
    "name": "Erdbeer-Aprikose (Frühlingsblüten), aromatisierter Grüntee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6306.jpg?v=1731344512",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "erdbeer-kiwi-tee",
    "name": "Erdbeer-Kiwi Tee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_444_image_1.jpg?v=1731345884",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "fit-schlank-tee-aromatisierter-schwarztee",
    "name": "Fit & Schlank Tee,aromatisierter Schwarztee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_361_image_1.jpg?v=1731344661",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "frauentee-krautertee",
    "name": "Frauentraum, Kräutertee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_383_image_1.jpg?v=1731345046",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "fruchtegarten-fruchtetee",
    "name": "Früchtegarten Früchtetee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6040.jpg?v=1731346017",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gabalong-gruntee-japan",
    "name": "Gabalong Grüntee - Japan",
    "price": 12.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_333_image_1.jpg?v=1731344197",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gruner-rooibostee-original",
    "name": "Grüner Rooibostee Original",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6400.jpg?v=1731345741",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gu-zhang-mao-jian-gruntee-china",
    "name": "Gu Zhang Mao Jian Grüntee - China",
    "price": 5.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_334_image_1.jpg?v=1731344222",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gummibarchen-fruchtetee",
    "name": "Gummibärchen-Früchtetee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_465_image_1.jpg?v=1731346283",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "gunpowder-china-gruntee",
    "name": "Gunpowder China Grüntee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_335_image_1.jpg?v=1731344246",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hatschi-tee-krautertee-tute-100g",
    "name": "Hatschi Tee - Kräutertee - Tüte 100g",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Hatschi-Kra-utertee.jpg?v=1731345220",
    "weight_g": 100,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "herrentoffee-aromatisierter-schwarztee",
    "name": "Herrentoffee, aromatisierter Schwarztee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5610.jpg?v=1731349371",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "herz-von-afrika-aromatisierter-gruntee",
    "name": "Herz von Afrika, aromatisierter Grüntee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_635_image_1.jpg?v=1731347261",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "holunderblute-ingwer-krautertee",
    "name": "Holunderblüte - Ingwer,Kräutertee",
    "price": 3.8,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_642_image_1.jpg?v=1731347423",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "honeybushtee-hexenwald",
    "name": "Honeybushtee Hexenwald",
    "price": 5.0,
    "category": "Tee",
    "tags": [
      "Honeybush"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_440_image_1.jpg?v=1731345807",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "honeybushtee-pur",
    "name": "Honeybushtee pur",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Honeybush"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/5951-Honeybush-pur.jpg?v=1731350013",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ingwer-schwarztee-aromatisierter-schwarztee",
    "name": "Ingwer Schwarztee, aromatisierter Schwarztee",
    "price": 3.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_620_image_1.jpg?v=1731343033",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "irish-cream-tee-aromatisierter-schwarztee",
    "name": "Irish Cream Tee, aromatisierter Schwarztee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_369_image_1.jpg?v=1731344800",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "jasmintee-china-gruntee-aromatisierter-gruntee",
    "name": "Jasmintee  - China Grüntee, aromatisierter Grüntee",
    "price": 5.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_341_image_1.jpg?v=1731344369",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "joongjak-gruntee",
    "name": "Joongjak Grüntee",
    "price": 8.7,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/JoongjakGT.jpg?v=1731351204",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "jubilaums-tee-schwarztee",
    "name": "Jubiläums-Tee Schwarztee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_320_image_1.jpg?v=1731343926",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "jungbrunnen-krautertee",
    "name": "Jungbrunnen - Kräutertee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_387_image_1.jpg?v=1731345119",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kinderkrautertee",
    "name": "Kinderkräutertee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5817.jpg?v=1731345196",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "kirschmichel",
    "name": "Kirschmichel",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6035.jpg?v=1731347498",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "lemon-star-detox-krautertee-mit-zitronengeschmack-aromatisierter-gruntee",
    "name": "Lemon Star Detox Kräutertee mit Zitronengeschmack, aromatisierter Grüntee",
    "price": 5.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert",
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/5797-Detox-Kr-tee.jpg?v=1731350307",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "magenperle-tee-krautertee",
    "name": "Magenperle Tee, Kräutertee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_385_image_1.jpg?v=1731345070",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "margarethe-s-hope-schwarztee",
    "name": "Margarethe`s Hope Schwarztee",
    "price": 7.5,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5008.jpg?v=1731347664",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "mate-tee-gerostet",
    "name": "Mate Tee - geröstet",
    "price": 6.0,
    "category": "Tee",
    "tags": [
      "Mate-Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_403_image_1.jpg?v=1731345390",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "mate-tee-grun",
    "name": "Mate Tee - grün",
    "price": 6.0,
    "category": "Tee",
    "tags": [
      "Mate-Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5830.jpg?v=1731345369",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "milde-himbeere-tee",
    "name": "Milde Himbeere Tee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_448_image_1.jpg?v=1731345989",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "nana-minze-tee-krautertee-tute-100g",
    "name": "Nana-Minze Tee - Kräutertee - Tüte 100g",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_399_image_1.jpg?v=1731345319",
    "weight_g": 100,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "nebeltee-gruntee-china",
    "name": "Nebeltee Grüntee China",
    "price": 6.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_338_image_1.jpg?v=1731344320",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "omas-garten-fruchtetee",
    "name": "Omas Garten Früchtetee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_453_image_1.jpg?v=1731346045",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "omas-ingwer-gruntee-aromatisierter-gruntee",
    "name": "Omas Ingwer Grüntee, aromatisierter Grüntee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_344_image_1.jpg?v=1731344421",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "orange-mit-schalen-tee-aromatisierter-schwarztee",
    "name": "Orange mit Schalen Tee, aromatisierter Schwarztee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_364_image_1.jpg?v=1731344737",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "original-k-c-popoff-gruntee-de-luxe",
    "name": "Original K&C POPOFF Grüntee de Luxe",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_336_image_1.jpg?v=1731344270",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "original-k-c-popoff-st-petersburger-teemischung-schwarztee",
    "name": "Original K&C POPOFF St. Petersburger Teemischung Schwarztee",
    "price": 3.8,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_324_image_1.jpg?v=1731344028",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "osterbluten-tee-aromatisierter-schwarztee-saisontee",
    "name": "Osterblüten-Tee, aromatisierter Schwarztee (Saisontee)",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5550.jpg?v=1731345000",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ostfriesen-krone-ceylon-orange-pekoe",
    "name": "Ostfriesen Krone - Ceylon Orange Pekoe",
    "price": 10.0,
    "category": "Tee",
    "tags": [
      "Klassische Teesorten"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5210.jpg?v=1731348644",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pfirsich-melba-fruchtetee",
    "name": "Pfirsich-Melba Früchtetee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_467_image_1.jpg?v=1731346335",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "pflaume-marzipan-fruchtetee",
    "name": "Pflaume-Marzipan Früchtetee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_443_image_1.jpg?v=1731345860",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "quelle-des-glucks-krautertee",
    "name": "Quelle des Glücks, Kräutertee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5857.jpg?v=1731347313",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rachenputzer-tee-krautertee",
    "name": "Rachenputzer Tee - Kräutertee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_386_image_1.jpg?v=1731345094",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rooibostee-african-dream",
    "name": "Rooibostee African Dream",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_410_image_1.jpg?v=1731345513",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rooibostee-eierlikor",
    "name": "Rooibostee Eierlikör",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5984.jpg?v=1731345669",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rooibostee-erdbeer-sahne",
    "name": "Rooibostee Erdbeer-Sahne",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_412_image_1.jpg?v=1731345566",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rooibostee-mandel-marzipan",
    "name": "Rooibostee Mandel/Marzipan",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6416.jpg?v=1731349322",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rooibostee-mango-maracuja",
    "name": "Rooibostee Mango-Maracuja",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_413_image_1.jpg?v=1731345591",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rooibostee-pfirsich",
    "name": "Rooibostee Pfirsich Grüntee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_414_image_1.jpg?v=1731345616",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rooibostee-pur",
    "name": "Rooibostee pur",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Rooibos"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_405_image_1.jpg?v=1731345438",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "rumtopf-tee",
    "name": "Rumtopf Tee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_468_image_1.jpg?v=1731346361",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sanddorn-tee-mit-fruchten",
    "name": "Sanddorn Tee mit Früchten",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_442_image_1.jpg?v=1731345834",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sanddorn-weissdorn-krautertee",
    "name": "Sanddorn-Weißdorn - Kräutertee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5884.jpg?v=1731347549",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schatz-der-inka-krautertee",
    "name": "Schatz der Inka, Kräutertee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5842.jpg?v=1731348416",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schietwettertee-ceylon-china-tee-mit-orangenschalen-und-aroma-aromatisierter-schwarztee",
    "name": "Schietwettertee - Ceylon-China-Tee mit Orangenschalen und Aroma,aromatisierter Schwarztee",
    "price": 3.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_382_image_1.jpg?v=1731345020",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schietwettertee-krautertee-mit-anis-geschmack",
    "name": "Schietwettertee - Kräutertee mit Anis-Geschmack",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5815.jpg?v=1731345171",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "schlaf-gut-krautertee",
    "name": "Schlaf gut - Kräutertee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_388_image_1.jpg?v=1731345146",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sencha-china-gruntee",
    "name": "Sencha China Grüntee",
    "price": 3.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_337_image_1.jpg?v=1731344296",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "sencha-orange-aromatisierter-gruntee",
    "name": "Sencha Orange, aromatisierter Grüntee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_634_image_1.jpg?v=1731347237",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "spezial-earl-grey-aromatisierter-schwarztee",
    "name": "Spezial Earl Grey,aromatisierter Schwarztee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_376_image_1.jpg?v=1731344890",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "terra-tulsi-orange-ingwer-tee-krautertee",
    "name": "Terra Tulsi Orange-Ingwer Tee - Kräutertee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_392_image_1.jpg?v=1731345244",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "traumfigur-krautertee",
    "name": "Traumfigur Kräutertee",
    "price": 5.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Traumfigur.jpg?v=1731351228",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "waldfrucht-tee",
    "name": "Waldfrucht Tee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_461_image_1.jpg?v=1731346235",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "waldzwerg-fruchtetee",
    "name": "Waldzwerg Früchtetee",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_445_image_1.jpg?v=1731345910",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "weisse-kirsche-china-teemischung-aromatisierter-weisser-tee",
    "name": "Weiße Kirsche China Teemischung, aromatisierter Weißer tee",
    "price": 5.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_339_image_1.jpg?v=1731344345",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "weisser-drache-weisser-tee-tute-100g",
    "name": "Weißer Drache - Weißer Tee -Tüte 100g",
    "price": 11.0,
    "category": "Tee",
    "tags": [
      "Grüner Tee"
    ],
    "image": "",
    "weight_g": 100,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "wildkirsch-tee-aromatisierter-schwarztee",
    "name": "Wildkirsch Tee,aromatisierter Schwarztee",
    "price": 3.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5400.jpg?v=1731344847",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "windstille-krautertee",
    "name": "Windstille, Kräutertee",
    "price": 4.5,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Kraeutertee-Windstille.jpg?v=1731347163",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "wintermarchen-saison-fruchtetee",
    "name": "Wintermärchen (Saison Früchtetee)",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_6090.jpg?v=1731346163",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "wintermarchen-aromatisierter-schwarztee-schwarzer-saisontee",
    "name": "Wintermärchen,aromatisierter Schwarztee (Schwarzer Saisontee)",
    "price": 4.9,
    "category": "Tee",
    "tags": [
      "Schwarzer Tee aromatisiert"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_5530.jpg?v=1731344954",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "basen-wohlfuhlkrautertee",
    "name": "Wohlfühlkräuter Basentee",
    "price": 5.0,
    "category": "Tee",
    "tags": [
      "Kräutertee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/6472-2.jpg?v=1738321761",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zimt-mit-pflaume-fruchtetee",
    "name": "Zimt mit Pflaume Früchtetee",
    "price": 4.0,
    "category": "Tee",
    "tags": [
      "Früchtetee"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_466_image_1.jpg?v=1731346308",
    "weight_g": null,
    "volume_ml": 300,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ammerlander-krautertrunk",
    "name": "Ammerländer Kräutertrunk",
    "price": 11.8,
    "category": "Wein & Spirituosen",
    "tags": [
      "Liköre"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/9037-Kr-auter-Trunk.jpg?v=1731349882",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "bischoffinger-weisser-burgunder-chardonnay-0-75l",
    "name": "Bischoffinger Weisser Burgunder & Chardonnay 0,75l",
    "price": 7.95,
    "category": "Wein & Spirituosen",
    "tags": [
      "Wein Deutsch"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/9135-WB-Chardonnay.jpg?v=1731351807",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "der-bad-zwischenahner-piepen-schluck",
    "name": "Der Bad Zwischenahner Piepen-Schluck",
    "price": 9.95,
    "category": "Wein & Spirituosen",
    "tags": [
      "Liköre"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/9035Rs9ilMmS1ZVFl.jpg?v=1731349862",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "hullmann-alter-korn-0-7-liter",
    "name": "HULLMANN »Alter Korn« | 0,7 Liter",
    "price": 19.8,
    "category": "Wein & Spirituosen",
    "tags": [
      "Klare",
      "Spirituosen"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/9020NOLOC6Uep9kXx.jpg?v=1731342218",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "ostfriesischer-moorgeist",
    "name": "Ostfriesischer Moorgeist",
    "price": 27.8,
    "category": "Wein & Spirituosen",
    "tags": [
      "Klare"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Moorgeist_Nr_9030_Schinkendiele.jpg?v=1731348725",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "vesper-prasent-nr-19",
    "name": "Vesper-Präsent Nr. 19",
    "price": 59.0,
    "category": "Wein & Spirituosen",
    "tags": [
      "Wein"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/19-Vesper-Pr-sent-1neu-jgp.jpg?v=1731347351",
    "weight_g": 1000,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zwischenahner-krauter-meerwasser-0-35l",
    "name": "Zwischenahner Kräuter - Meerwasser,0,35l",
    "price": 7.95,
    "category": "Wein & Spirituosen",
    "tags": [
      "Liköre"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_214_image_1.jpg?v=1731342143",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  },
  {
    "id": "zwischenahner-sanddorn-meerwasser-0-35l",
    "name": "Zwischenahner Sanddorn - Meerwasser,0,35l",
    "price": 7.95,
    "category": "Wein & Spirituosen",
    "tags": [
      "Liköre"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_215_image_1.jpg?v=1731342167",
    "weight_g": null,
    "volume_ml": 1200,
    "vegetarian": false,
    "vegan": false,
    "popularity": 0
  }
];

window.KONFIG_BASKETS =
[
  {
    "id": "karton-2er",
    "name": "2er Geschenkkarton",
    "description": "Eleganter Wellpapp-Karton mit Goldprägung 'Das Ammerland' für 2 Produkte",
    "capacity_ml": 6000,
    "max_items": 3,
    "price": 0,
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/ChatGPT_Image_25._Maerz_2026_18_04_17.png?v=1774458562",
    "dimensions": "36 x 19 x 10 cm",
    "colors": ["rot", "grün", "blau"]
  },
  {
    "id": "karton-3er",
    "name": "3er Geschenkkarton",
    "description": "Großer Wellpapp-Karton mit Goldprägung 'Das Ammerland' für 3 Produkte",
    "capacity_ml": 8500,
    "max_items": 5,
    "price": 0,
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/ChatGPT_Image_25._Maerz_2026_18_05_53.png?v=1774458562",
    "dimensions": "36 x 26 x 10 cm",
    "colors": ["rot", "grün", "blau"]
  },
  {
    "id": "korb-klein",
    "name": "Kleiner Korb",
    "description": "Flaches Seegras-Tablett für eine handverlesene Auswahl",
    "capacity_ml": 4000,
    "max_items": 4,
    "price": 0,
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/ChatGPT_Image_25._Maerz_2026_17_41_20.png?v=1774458563",
    "dimensions": "31 x 21 x 10 cm"
  },
  {
    "id": "kiepe-klein",
    "name": "Kleine Kiepe",
    "description": "Traditionelle Ammerländer Kiepe aus dunklem Weidengeflecht",
    "capacity_ml": 12000,
    "max_items": 8,
    "price": 0,
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/ChatGPT_Image_25._Maerz_2026_17_45_58.png?v=1774458563",
    "dimensions": "40 x 23 x 25 cm"
  },
  {
    "id": "korb-gross",
    "name": "Großer Korb",
    "description": "Klassischer Weidenkorb mit Henkel – der Geschenkkorb-Klassiker",
    "capacity_ml": 20000,
    "max_items": 14,
    "price": 0,
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/ChatGPT_Image_25._Maerz_2026_17_51_24.png?v=1774458562",
    "dimensions": "43 x 29 x 32 cm"
  },
  {
    "id": "kiepe-gross",
    "name": "Große Kiepe",
    "description": "Stattliche Ammerländer Kiepe für ein üppiges Genusspaket",
    "capacity_ml": 20000,
    "max_items": 16,
    "price": 0,
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/ChatGPT_Image_25._Maerz_2026_17_43_29.png?v=1774458564",
    "dimensions": "48 x 29 x 29 cm"
  }
]
;

window.KONFIG_PRAESENTE = 
[
  {
    "id": "ostfriesen-prasent-nr-72",
    "name": "Ostfriesen-Präsent Nr. 72",
    "price": 14.9,
    "tags": [
      "Klassische Teesorten",
      "Sonstige",
      "Teepräsente",
      "Vegetarische Produkte",
      "Zubehör54"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ostfriesen_Praesent_Nr_72_Schinkendiele.jpg?v=1731349817",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": false,
    "has_tea": true,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 21,
    "short_description": "Ostfriesisches Teegeschenk – Traditionell &amp; Authentisch Tauchen Sie ein in die ostfriesische Teekultur! Mit unserem Ostfriesischen Teegeschenk bringen Sie die Tradition direkt in Ihr Zuhause. Perf",
    "shop_url": "https://schinkendiele.de/products/ostfriesen-prasent-nr-72"
  },
  {
    "id": "ostfriesen-wurst-tee-prasent-nr-83",
    "name": "Ostfriesen-Wurst-Tee-Präsent Nr. 83",
    "price": 15.0,
    "tags": [
      "Sonstige",
      "Teepräsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ostfriesen_Wurst_Tee_Praesent_Nr_83.jpg?v=1731340196",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": true,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 10,
    "short_description": "Feinschmecker-Präsent: Ostfriesische Teestunde &amp; Drögt-Mettwurst Ein Genuss-Paket für Liebhaber norddeutscher Spezialitäten Dieses stilvolle Präsent kombiniert kräftigen Ostfriesentee mit einer lu",
    "shop_url": "https://schinkendiele.de/products/ostfriesen-wurst-tee-prasent-nr-83"
  },
  {
    "id": "prasent-teestunde-nr-71",
    "name": "Präsent \"Teestunde\" Nr. 71",
    "price": 23.5,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Teepräsente",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Praesentkorb-Teestunde-Nr-71.jpg?v=1731349768",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": false,
    "has_tea": true,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 19,
    "short_description": "Inhalt: Eine Tüte Ostfriesische Teestunde 100g Eine Tüte Butter-Friesen-Gebäck 250g Eine Tüte Brauner Krustenkandis 250g Ein Glas Himbeer-Konfitüre 250g Ein Brühteelöffel mit Klappdeckel 15,5 cm Alles",
    "shop_url": "https://schinkendiele.de/products/prasent-teestunde-nr-71"
  },
  {
    "id": "kleine-brotzeit-prasent-nr-51",
    "name": "Kleine Brotzeit-Präsent Nr. 51",
    "price": 27.5,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_51.jpg?v=1731351017",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 10,
    "short_description": "Inhalt des Präsents : Geräucherter Katenschinken \"Ammerländer Art\" (ca. 500g) Schinken-Mettwurst (160g) Golden Köpke schwarzer Tee (100g) Weißer Kandis (250g) Verpackt in einem kleinen, geschlossenen ",
    "shop_url": "https://schinkendiele.de/products/kleine-brotzeit-prasent-nr-51"
  },
  {
    "id": "der-frauenabend",
    "name": "Der Frauenabend",
    "price": 28.0,
    "tags": [
      "Präsentkartons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/67-Frauenabend.jpg?v=1731353398",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 12,
    "short_description": "Inhalt des Präsentsets: 1x Makkaroni 500g 1x Tomatensoße Ricotta 375ml 1x Merlot Rotwein 0,7l 1x Café de Paris-Dipp 1x Käsekräcker Scrocchi Im Präsentkarton mit Cello/Schleife Makkaroni: Zutaten: Hart",
    "shop_url": "https://schinkendiele.de/products/der-frauenabend"
  },
  {
    "id": "aalrauch-bauernmettwurst-prasent-nr-21",
    "name": "Aalrauch-Bauernmettwurst- Präsent Nr. 21",
    "price": 29.0,
    "tags": [
      "Ammerland-Präsente",
      "Mettwurst",
      "Präsentkartons",
      "Salami",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Allrauch_Bauernmettwurst_Praesent_Nr_21_Schinkendiele.jpg?v=1731340172",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 20,
    "short_description": "Traditionelle Aalrauch-Bauern-Mettwurst – Fettarm &amp; Herzhaft Rustikaler Genuss mit besonderem Raucharoma Diese fettarme Mettwurst (unter 20 % Fett) wird nach traditioneller Handwerkskunst hergeste",
    "shop_url": "https://schinkendiele.de/products/aalrauch-bauernmettwurst-prasent-nr-21"
  },
  {
    "id": "valentin-prasent-nr-78",
    "name": "Valentin-Präsent Nr. 78",
    "price": 30.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/78-Guten-Abend-Pr-sent.jpg?v=1731351701",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 10,
    "short_description": "Das perfekte Geschenk – Eine genussvolle Zusammenstellung für jeden Anlass Dieses exklusive Geschenkset enthält eine ausgewählte Kombination von hochwertigen Delikatessen , die zu jeder Gelegenheit di",
    "shop_url": "https://schinkendiele.de/products/valentin-prasent-nr-78"
  },
  {
    "id": "prasent-sonntagstee-nr-70",
    "name": "Präsent \"Sonntagstee\" Nr. 70",
    "price": 30.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Teepräsente",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/70-Sonntagstee_Pr-sent_ASXE2e7JwIOe3qC.jpg?v=1731349793",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": true,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 18,
    "short_description": "Ostfriesisches Geschenkset – Perfekt für Teeliebhaber Dieses wunderschöne Geschenkset aus Ostfriesland ist ein absolutes Muss für alle Teeliebhaber und jene, die es noch werden möchten. Es enthält all",
    "shop_url": "https://schinkendiele.de/products/prasent-sonntagstee-nr-70"
  },
  {
    "id": "der-kleine-ammerlander-prasent-nr-52",
    "name": "Der kleine Ammerländer - Präsent Nr. 52",
    "price": 32.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_52.jpg?v=1731351040",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 8,
    "short_description": "Inhalt des Präsents : Landschinken, luftgetrocknet (ca. 500g) Die kleine Sommermettwurst (350g) Tomatenleberwurst (180g) Verpackt in einem geschlossenen Präsentkarton . Hinweis : Gewichts-, Preis- und",
    "shop_url": "https://schinkendiele.de/products/der-kleine-ammerlander-prasent-nr-52"
  },
  {
    "id": "klein-fein-prasent-nr-47",
    "name": "Klein + Fein Präsent Nr. 47",
    "price": 32.0,
    "tags": [
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Klein_und_Fein_Praesent_47_Schinkendiele-bearbeitet.jpg?v=1749043021",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 11,
    "short_description": "Inhalt: ein Stück Nuss-Schinken ca. 500g mit leichter Buchenholznote eine Aalrauchmettwurst, streichfähig ca. 250g eine Drögt Mettwurst im Ring ca. 250g Alles hübsch verpackt in einem geschlossenen Pr",
    "shop_url": "https://schinkendiele.de/products/klein-fein-prasent-nr-47"
  },
  {
    "id": "nuss-schinken-prasent-nr-14",
    "name": "Nuss-Schinken-Präsent Nr. 14",
    "price": 32.0,
    "tags": [
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Nuss_Schinken_Praesent_Nr_14_Schinkendiele_6257da01-7953-491d-a938-99eb7c2bb321.jpg?v=1731339542",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 23,
    "short_description": "Feinster Rohschinken aus magerem Hinterschinken, mild geräuchert Unser Ammerländer Nuss-Schinken ist eine hochwertige Schinkenspezialität , die nach alter Bauerntradition über Buchenholz geräuchert wi",
    "shop_url": "https://schinkendiele.de/products/nuss-schinken-prasent-nr-14"
  },
  {
    "id": "der-europaer",
    "name": "Der Europäer",
    "price": 34.0,
    "tags": [
      "Präsentkartons",
      "Sonstige",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/86-Der-Europ-er.jpg?v=1731353636",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 9,
    "short_description": "Inhalt des Präsentkartons Ammerland rot: 1x Makkaroni 500g Zutaten : Hartweizengries, Eier (20%). Kann Spuren von Soja enthalten. Nährwerte je 100g : Brennwert: 1514 kJ / 358 kcal Fett: 3,5 g (davon g",
    "shop_url": "https://schinkendiele.de/products/der-europaer"
  },
  {
    "id": "prasent-valentina-nr-77",
    "name": "Präsent \"Valentina\" Nr. 77",
    "price": 34.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Prasent-Valentina.jpg?v=1731351684",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "klein",
    "item_count": 31,
    "short_description": "Verschenken Sie mit Herz, ein herzlicher Genuss. Inhalt: 4 Wattwürmer in Herzform (Mettwurst), eine 0,2l Flasche Pinot Sekt extra trocken von Bischoffingen vom Kaiserstuhl, eine Packung feinste Trüffe",
    "shop_url": "https://schinkendiele.de/products/prasent-valentina-nr-77"
  },
  {
    "id": "prasent-snackabend",
    "name": "Präsent Snackabend",
    "price": 37.0,
    "tags": [
      "Käse/Milchprodukte",
      "Präsentkartons",
      "Sonstige",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/81-Pr-sent-Snackabend.jpg?v=1731353578",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": true,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 25,
    "short_description": "Genussbox \"Feigen &amp; Käse\" – Das perfekte Präsent Überraschen Sie Ihre Liebsten oder sich selbst mit einer exquisiten Zusammenstellung an feinen Delikatessen. Diese besondere Genussbox enthält hoch",
    "shop_url": "https://schinkendiele.de/products/prasent-snackabend"
  },
  {
    "id": "nudelprasent-kristall",
    "name": "Nudelpräsent Kristall",
    "price": 38.0,
    "tags": [
      "Käse/Milchprodukte",
      "Präsentkartons",
      "Sonstige",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/80-Nudelpr-sent-Kristall.jpg?v=1731353559",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": false,
    "has_tea": false,
    "has_cheese": true,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 11,
    "short_description": "Inhalt: 1x Knoblauchnudeln 500g 1x Golden Köppke Schwarztee 100g 1x Ostfriesenkandis weiß 250g 1x Oliven 292g 1x Scrocchi Kräcker 175g 1x Zuckerzwieback 150g 1x Gouda Kristall 240g 1x Tomatensoße-Somm",
    "shop_url": "https://schinkendiele.de/products/nudelprasent-kristall"
  },
  {
    "id": "ammerlander-abendbrotkorb-nr-22",
    "name": "Ammerländer Abendbrotkorb Nr. 22",
    "price": 38.0,
    "tags": [
      "Ammerland-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/22Abendbrotpraesent-bearbeitet.jpg?v=1749043280",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 45,
    "short_description": "Inhalt: Eine Packung Katenschinken ca. 200g, geräuchert als Servierschnitt. Eine Drögt Mettwurst im Ring, ca. 250g, eine luftgetrocknete Spezialität. Ein Glas Schinken-Leberwurst, 160g, herzhaft mit S",
    "shop_url": "https://schinkendiele.de/products/ammerlander-abendbrotkorb-nr-22"
  },
  {
    "id": "kase-prasentkorb-nr-50-kase-geschenk-mit-kostlichem-gouda-franzosischem-camembert-glas-feigensenf",
    "name": "Käse-Präsentkorb Nr. 50 x",
    "price": 40.0,
    "tags": [
      "Käse/Milchprodukte",
      "Sonstige",
      "Vegetarische Produkte",
      "Wein",
      "Wein-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/50-K-sepr-sent.jpg?v=1731348075",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": true,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 17,
    "short_description": "Käse-Geschenk mit köstlichem Gouda, französischem Camembert, Glas Feigensenf. Über dieses Käse-Geschenk mit allerlei Köstlichkeiten freuen sich nicht nur verwöhnte Käsefreunde. Dieser günstige Käse-Ge",
    "shop_url": "https://schinkendiele.de/products/kase-prasentkorb-nr-50-kase-geschenk-mit-kostlichem-gouda-franzosischem-camembert-glas-feigensenf"
  },
  {
    "id": "dielen-wurfel-nr-46",
    "name": "Dielen-Würfel Nr. 46",
    "price": 40.0,
    "tags": [
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Dielen_Wuerfel_46_Schinkendiele.jpg?v=1731341914",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 14,
    "short_description": "Feines Ammerländer Genuss-Paket – Deftige Spezialitäten im Präsentkarton Ein echtes Highlight für Liebhaber herzhafter Spezialitäten: Unser Ammerländer Genuss-Paket vereint traditionelle Wurst- und Sc",
    "shop_url": "https://schinkendiele.de/products/dielen-wurfel-nr-46"
  },
  {
    "id": "susses-teeprasent-ammerland-rot-nr-33",
    "name": "Süsses Teepräsent Ammerland Nr. 33",
    "price": 40.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Teepräsente",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Tee-Praesentkorb-33qSaLPpBAnaMeC.jpg?v=1731339868",
    "has_meat": false,
    "has_fish": false,
    "has_alcohol": false,
    "has_tea": true,
    "has_cheese": false,
    "is_vegetarian": true,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 28,
    "short_description": "Feinste Genussbox „Ostfriesische Teestunde“ – Tee, Süßes &amp; Honiggenuss Erleben Sie eine erlesene Auswahl an köstlichen Tees, feinen Süßwaren und hochwertigem Honig – perfekt für eine entspannte Te",
    "shop_url": "https://schinkendiele.de/products/susses-teeprasent-ammerland-rot-nr-33"
  },
  {
    "id": "genuss-wurfel-nr-43",
    "name": "Genuss-Würfel Nr. 43",
    "price": 43.0,
    "tags": [
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Genuss_Wuerfel_43_Schinkendiele_1_-bearbeitet.jpg?v=1749043196",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 18,
    "short_description": "Inhalt: ein Stück Nuss-Schinken, ca. 500g, magerer Hinterschinken ohne Fett und Schwartemit leichter Buchenholznote ein Glas Frühstücksmettwurst 200g ein Glas Gänse-Schmaus 125g eine Aalrauchmettwurst",
    "shop_url": "https://schinkendiele.de/products/genuss-wurfel-nr-43"
  },
  {
    "id": "probierpaket-nr-88-lernen-sie-unsere-beliebtesten-produkte-kennen",
    "name": "Probierpaket Nr. 88 - Lernen Sie unsere beliebtesten Produkte kennen",
    "price": 45.0,
    "tags": [
      "Präsentkartons",
      "Salami",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Probierpaket_Nr_88_Schinkendiele.jpg?v=1731347194",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 39,
    "short_description": "Ammerländer Schinken-Wurst-Probierpaket – Zum Sonderpreis! Tauchen Sie ein in die Welt der Ammerländer Schinken- und Wurstspezialitäten ! Dieses herzhaft zusammengestellte Probierpaket bietet eine vie",
    "shop_url": "https://schinkendiele.de/products/probierpaket-nr-88-lernen-sie-unsere-beliebtesten-produkte-kennen"
  },
  {
    "id": "schinken-wurst-teeprasent-nr-57",
    "name": "Schinken-Wurst-Teepräsent Nr. 57",
    "price": 45.0,
    "tags": [
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Pr-sent-Nr-57-neu-2020.jpg?v=1731340123",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 33,
    "short_description": "Feinschmecker-Geschenkkorb „Ammerländer Genusswelt“ – Delikatessen aus Norddeutschland Das perfekte Geschenk für Genießer Dieser exklusive Geschenkkorb vereint herzhaft-würzigen Schinken, traditionell",
    "shop_url": "https://schinkendiele.de/products/schinken-wurst-teeprasent-nr-57"
  },
  {
    "id": "ammerland-prasent-nr-8",
    "name": "Ammerland-Präsent Nr. 8",
    "price": 46.5,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ammerlaender_Praesent_Nr_8.jpg?v=1731339500",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 16,
    "short_description": "Feinschmecker-Set „Ammerländer Landgenuss“ – Tradition trifft auf Geschmack Dieses liebevoll zusammengestellte Set vereint das Beste der norddeutschen Wurst- und Schinken-Tradition . Die sorgfältig au",
    "shop_url": "https://schinkendiele.de/products/ammerland-prasent-nr-8"
  },
  {
    "id": "grunkohl-prasent-nr-87",
    "name": "Grünkohl-Präsent Nr. 87",
    "price": 48.0,
    "tags": [
      "Ammerland-Präsente",
      "Grünkohlzeit",
      "Präsentkartons",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_87.jpg?v=1731350189",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": true,
    "size": "mittel",
    "item_count": 9,
    "short_description": "Herzhaftes Grünkohl-Präsent – Norddeutsche Spezialitäten im Ammerland-Karton Freuen Sie sich auf ein echtes norddeutsches Geschmackserlebnis! Dieses liebevoll zusammengestellte Präsent vereint traditi",
    "shop_url": "https://schinkendiele.de/products/grunkohl-prasent-nr-87"
  },
  {
    "id": "weisswein-schinken-prasent-nr-59",
    "name": "Weißwein-Schinken-Präsent Nr. 59",
    "price": 48.0,
    "tags": [
      "Präsentkartons",
      "Schinken-Präsente",
      "Wein",
      "Wein-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_59neu.jpg?v=1731340220",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 20,
    "short_description": "Edles Feinschmecker-Präsent – Landschinken, Weißwein &amp; Mettwurst Hochwertige Spezialitäten für Genießer Dieses exklusive Präsent vereint herzhafte Delikatessen mit einem edlen Tropfen Weißwein – p",
    "shop_url": "https://schinkendiele.de/products/weisswein-schinken-prasent-nr-59"
  },
  {
    "id": "teeprasent-schwarzer-tee-nr-73",
    "name": "Teepräsent »Schwarzer Tee« Nr. 73",
    "price": 48.0,
    "tags": [
      "Präsentkartons",
      "Teepräsente",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Teepraesent_Schwarzer_Tee_Nr_73_Schinkendiele.jpg?v=1731340060",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": true,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 43,
    "short_description": "Ostfriesisches Teegenuss-Set – Hochwertige Teespezialitäten &amp; Zubehör Perfekt für Teeliebhaber &amp; Genießer Dieses exklusive Tee-Geschenkset vereint edle ostfriesische Schwarztees, feinen Honig,",
    "shop_url": "https://schinkendiele.de/products/teeprasent-schwarzer-tee-nr-73"
  },
  {
    "id": "zwischenahner-raucheraal-prasent-nr-20",
    "name": "Zwischenahner Räucheraal-Präsent Nr. 20",
    "price": 48.9,
    "tags": [
      "Fisch",
      "Fisch-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_48_image_1.jpg?v=1731339633",
    "has_meat": true,
    "has_fish": true,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 21,
    "short_description": "Zwischenahner Räucheraal-Präsent Nr. 20 – Hochwertigen Aal kaufen Edle Fischspezialität für echte Genießer Unser Zwischenahner Räucheraal ist eine echte Delikatesse aus dem Ammerland – traditionell ge",
    "shop_url": "https://schinkendiele.de/products/zwischenahner-raucheraal-prasent-nr-20"
  },
  {
    "id": "feinschmecker-prasent-nr-41",
    "name": "Feinschmecker-Präsent Nr. 41",
    "price": 49.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/41-neu-2020.jpg?v=1731339986",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 45,
    "short_description": "Ammerländer Spezialitätenbox – Feinkost für Genießer Ein echtes Geschmackserlebnis für Liebhaber herzhaft-norddeutscher Spezialitäten! Unsere Ammerländer Spezialitätenbox vereint die besten regionalen",
    "shop_url": "https://schinkendiele.de/products/feinschmecker-prasent-nr-41"
  },
  {
    "id": "prasent-herzhaft-nr-29",
    "name": "Präsent Herzhaft- Nr. 29",
    "price": 49.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/29-Pr-sent-Herzhaft-1neugPWjicMpueSxi.jpg?v=1731339761",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 34,
    "short_description": "Ammerländer Genussbox – Herzhafte Wurstspezialitäten &amp; Pumpernickel Feinste norddeutsche Spezialitäten in einer stilvollen Präsentbox – für Feinschmecker &amp; Genießer! Unsere Ammerländer Genussb",
    "shop_url": "https://schinkendiele.de/products/prasent-herzhaft-nr-29"
  },
  {
    "id": "der-herrenabend-nr-69",
    "name": "Der Herrenabend- Nr. 69",
    "price": 50.0,
    "tags": [
      "Präsentkartons",
      "Präsentkörbe"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/69-Herrenabend.jpg?v=1731353418",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 8,
    "short_description": "Inhalt des Präsentsets: 1x Makkaroni 500g 1x Katenschinken 500g 1x Mainova Azeite, kaltgepresstes Olivenöl, Portugal 500ml 1x Dose Oliven 300ml 1x Bella Crema - Nudelsoße 1x Parmesankäse 250g Im Präse",
    "shop_url": "https://schinkendiele.de/products/der-herrenabend-nr-69"
  },
  {
    "id": "feinkost-prasent-nr-39",
    "name": "Feinkost-Präsent Nr. 39",
    "price": 51.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/39-Feinkost-Pr-sent-1neu.jpg?v=1731339927",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 40,
    "short_description": "Ammerländer Genussbox – Herzhafte Wurstspezialitäten &amp; Feinkost Edle norddeutsche Spezialitäten in einer hochwertigen Präsentkarton – ideal für Genießer &amp; Feinschmecker! Unsere Ammerländer Gen",
    "shop_url": "https://schinkendiele.de/products/feinkost-prasent-nr-39"
  },
  {
    "id": "ammerlander-geniesser-prasent-nr-36",
    "name": "Ammerländer-Genießer-Präsent Nr. 36",
    "price": 51.0,
    "tags": [
      "Präsentkartons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Schinken_Wurst_Tee_Praesent_Ammerland_Rot_Nr_36_Schinkendiele.jpg?v=1731339893",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 12,
    "short_description": "Norddeutsche Genussbox – Traditionelle Spezialitäten aus dem Ammerland Genießen Sie eine exklusive Auswahl feinster norddeutscher Spezialitäten! Diese Genussbox vereint herzhaft geräucherte Wurst- und",
    "shop_url": "https://schinkendiele.de/products/ammerlander-geniesser-prasent-nr-36"
  },
  {
    "id": "mahlzeit-prasent-ammerland-grun-nr-37",
    "name": "Mahlzeit-Präsent Ammerland -Grün- Nr. 37",
    "price": 52.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/37Neu2020-bearbeitet.jpg?v=1749042418",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 38,
    "short_description": "Ammerländer Spezialitätenbox – Herzhaft &amp; Süß Feinste norddeutsche Delikatessen in einer hochwertigen Präsentbox – für echte Genießer! Unsere Ammerländer Spezialitätenbox vereint herzhafte und süß",
    "shop_url": "https://schinkendiele.de/products/mahlzeit-prasent-ammerland-grun-nr-37"
  },
  {
    "id": "liebhaber-prasent-nr-48",
    "name": "Liebhaber-Präsent Nr. 48",
    "price": 54.0,
    "tags": [
      "Präsentkartons",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/48-Liebhaberpr-sent.jpg?v=1731340094",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 28,
    "short_description": "Feinschmecker-Geschenkset „Ammerländer Delikatessen“ – Beste Spezialitäten aus Norddeutschland Perfektes Geschenk für Genießer &amp; Feinschmecker Dieses exklusive Präsentset vereint traditionelle Wur",
    "shop_url": "https://schinkendiele.de/products/liebhaber-prasent-nr-48"
  },
  {
    "id": "teezeitprasent-nr-32",
    "name": "Teezeitpräsent Nr. 32",
    "price": 54.0,
    "tags": [
      "Präsentkartons",
      "Teepräsente",
      "Vegetarische Produkte"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Pr-sent-Nr-32-neu.jpg?v=1731339784",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": true,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 53,
    "short_description": "Teezeitpräsent „Süßes aus dem Ammerland“ – Feine Tees &amp; Leckereien Feinste Teespezialitäten und süße Köstlichkeiten aus dem Ammerland – ein Genuss für Teeliebhaber und Feinschmecker! Unser Teezeit",
    "shop_url": "https://schinkendiele.de/products/teezeitprasent-nr-32"
  },
  {
    "id": "festtags-prasent-nr-44",
    "name": "Festtags-Präsent Nr. 44",
    "price": 55.0,
    "tags": [
      "Präsentkartons",
      "Schinken-Präsente",
      "Sonstige",
      "Weihnachts-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/44-Festtags-Pr-sent.jpg?v=1731340253",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": true,
    "is_kale": false,
    "size": "mittel",
    "item_count": 20,
    "short_description": "Festliche Genussbox – Edle Spezialitäten aus dem Ammerland Dieses exklusive Präsent vereint eine handverlesene Auswahl an erlesenen Köstlichkeiten aus dem Ammerland. Ob als Geschenk zu Weihnachten, fü",
    "shop_url": "https://schinkendiele.de/products/festtags-prasent-nr-44"
  },
  {
    "id": "schinken-wurst-prasent-nr-40",
    "name": "Schinken-Wurst-Präsent Nr. 40",
    "price": 56.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/40-bearbeitet.png?v=1749042588",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 39,
    "short_description": "Ammerländer Delikatessenbox – Edle Wurstspezialitäten &amp; Gänseschmaus Feinste norddeutsche Spezialitäten in einer hochwertigen Präsentbox – für Genießer &amp; Feinschmecker! Unsere Ammerländer Deli",
    "shop_url": "https://schinkendiele.de/products/schinken-wurst-prasent-nr-40"
  },
  {
    "id": "schietwetter-prasent-nr-45",
    "name": "Schietwetter-Präsent Nr. 45",
    "price": 58.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Teepräsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/45-Schietwetter.jpg?v=1731340036",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": true,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 38,
    "short_description": "Ammerländer Schlemmerpaket – Traditionelle Spezialitäten in edler Geschenkbox Ein Fest für Feinschmecker &amp; Liebhaber norddeutscher Spezialitäten Dieses exklusive Präsent vereint die besten Ammerlä",
    "shop_url": "https://schinkendiele.de/products/schietwetter-prasent-nr-45"
  },
  {
    "id": "schlecker-prasent-ammerland-grun-nr-38",
    "name": "Schlecker-Präsent Ammerland -Grün- Nr. 38",
    "price": 59.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Schinken_Wurst_Praesent_Ammerland_Gruen_Nr_38_Schinkendiele.jpg?v=1731339845",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "mittel",
    "item_count": 40,
    "short_description": "Ammerländer Delikatessenbox – Edle Wurstspezialitäten &amp; Gänseschmaus Feinste norddeutsche Spezialitäten in einer hochwertigen Präsentbox – für Genießer &amp; Feinschmecker! Unsere Ammerländer Deli",
    "shop_url": "https://schinkendiele.de/products/schlecker-prasent-ammerland-grun-nr-38"
  },
  {
    "id": "rotwein-schinken-prasent-nr-58",
    "name": "Rotwein-Schinken-Präsent Nr. 58",
    "price": 62.5,
    "tags": [
      "Präsentkartons",
      "Schinken-Präsente",
      "Wein",
      "Wein-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_58neu.jpg?v=1731340148",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 43,
    "short_description": "Feinschmecker-Präsent „Ammerländer Genuss“ – Gewürzschinken, Rotwein &amp; Trüffel Ein exklusives Geschmackserlebnis für Genießer Dieses hochwertige Präsent vereint herzhaft-würzigen Gewürzschinken, e",
    "shop_url": "https://schinkendiele.de/products/rotwein-schinken-prasent-nr-58"
  },
  {
    "id": "gewurzschinken-prasent-nr-13",
    "name": "Gewürzschinken-Präsent Nr. 13",
    "price": 65.0,
    "tags": [
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Gewurzschinken_Praesent_Nr_13_Schinkendiele.jpg?v=1731339609",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 28,
    "short_description": "8 Monate gereifter Gewürzschinken – Handgesalzen &amp; Luftgetrocknet Feinste Handwerkskunst für höchsten Genuss Unser naturgereifter Gewürzschinken ist eine echte Delikatesse für Feinschmecker. Handg",
    "shop_url": "https://schinkendiele.de/products/gewurzschinken-prasent-nr-13"
  },
  {
    "id": "prasent-loffelschluck-mit-schinkenplatte-nr-10",
    "name": "Präsent Löffelschluck mit Schinkenplatte Nr. 10",
    "price": 65.0,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/No_10neu.jpg?v=1731339437",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 29,
    "short_description": "Feinschmecker-Set “Ammerländer Genuss” – Tradition in edler Verpackung Entdecken Sie die norddeutsche Genusskultur in einer stilvollen Präsentbox. Dieses Set vereint traditionelle Delikatessen aus dem",
    "shop_url": "https://schinkendiele.de/products/prasent-loffelschluck-mit-schinkenplatte-nr-10"
  },
  {
    "id": "gaumenfreude-prasent-nr-42",
    "name": "Gaumenfreude-Präsent Nr. 42",
    "price": 69.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/42Karton-bearbeitet-bearbeitet.jpg?v=1749042723",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 40,
    "short_description": "Ammerländer Genussbox – Traditionelle Spezialitäten für Feinschmecker 🎁 Das perfekte Geschenk für Liebhaber deftiger Wurst- &amp; Schinkenspezialitäten! Diese exklusive Präsentbox bietet eine erlesene",
    "shop_url": "https://schinkendiele.de/products/gaumenfreude-prasent-nr-42"
  },
  {
    "id": "kostlichkeiten-korb-nr-6-herzhaft-mit-wurst-schinken",
    "name": "Köstlichkeiten Korb Nr. 6 Herzhaft mit Wurst + Schinken",
    "price": 69.0,
    "tags": [
      "Schinken-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_34_image_1.jpg?v=1731339307",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 17,
    "short_description": "Dieser herzhafte Geschenkkorb besticht durch seine besonderen Wurstspezialitäten aus der Ammerländer Region. Hübsch verpackt mit ausgewählten Schinken- und Wurstdelikatessen. Mit roten Servietten, rot",
    "shop_url": "https://schinkendiele.de/products/kostlichkeiten-korb-nr-6-herzhaft-mit-wurst-schinken"
  },
  {
    "id": "norwegisches-graved-lachs-prasent-1000g-nr-25",
    "name": "Norwegisches Graved Lachs-Präsent | 1000g, Nr. 25",
    "price": 74.0,
    "tags": [
      "Fisch",
      "Fisch-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/product_53_image_1.jpg?v=1731339707",
    "has_meat": true,
    "has_fish": true,
    "has_alcohol": false,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 6,
    "short_description": "Graved Lachs – Nach norwegischem Original-Rezept Unser Graved Lachs wird nach traditioneller norwegischer Art aus feinstem Salmo Salar Superior hergestellt. Diese besondere Delikatesse zeichnet sich d",
    "shop_url": "https://schinkendiele.de/products/norwegisches-graved-lachs-prasent-1000g-nr-25"
  },
  {
    "id": "raucherlachs-prasent-1000g-nr-23",
    "name": "Räucherlachs-Präsent 1000g, Nr. 23",
    "price": 74.0,
    "tags": [
      "Fisch",
      "Fisch-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Raucherlachs_Praesent_Nr_23_Schinkendiele.jpg?v=1731339658",
    "has_meat": true,
    "has_fish": true,
    "has_alcohol": false,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 13,
    "short_description": "Feinster Räucherlachs – Salmo Salar Superior aus Norwegen Unser Räucherlachs “Salmo Salar Superior” stammt aus den klaren Gewässern der norwegischen Fjorde und überzeugt durch seine außergewöhnliche Q",
    "shop_url": "https://schinkendiele.de/products/raucherlachs-prasent-1000g-nr-23"
  },
  {
    "id": "fruhstucks-prasent-nr-53",
    "name": "Frühstücks-Präsent Nr. 53",
    "price": 78.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Schinken-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/53-Fr-hst-cks-Pr-sent.jpg?v=1731353019",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 67,
    "short_description": "Nicht nur zum Frühstück, auch zum Abendbrot oder zum Vespern, ein Genuss. Inhalt: Katenschinken, 500g im Stück Ammerländer Mettwurst im Ring, 200g Aalrauchmettwurst, Streichfähige Kugel, ca. 250g Klei",
    "shop_url": "https://schinkendiele.de/products/fruhstucks-prasent-nr-53"
  },
  {
    "id": "kiepe-ammerland-nr-30",
    "name": "Kiepe - Ammerland Nr. 30",
    "price": 87.0,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Kiepe_Ammerland_Nr_30_Schinkendiele.jpg?v=1731348101",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 27,
    "short_description": "Für alle Kenner der Ammerländer Spezialitäten oder für solche die es noch werden wollen, bietet dieser Geschenkkorb eine große Auswahl an Leckereien aus der norddeutschen Region. Liebevoll verpackt in",
    "shop_url": "https://schinkendiele.de/products/kiepe-ammerland-nr-30"
  },
  {
    "id": "prasent-im-schmuckkarton-natur-nr-35",
    "name": "Präsent im Schmuckkarton, natur, Nr. 35",
    "price": 92.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Schinken-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/35-Pr-sent-in-Natur.jpg?v=1731353070",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "groß",
    "item_count": 66,
    "short_description": "Ein schöner Genusskorb zum Verschenken für jede Gelegenheit. Inhalt: Gewürzschinken im Stück ca. 400g Katenschinken, Servierschnitt ca.200g Aalrauch-Bauern-Mettwurst ca. 500g Aalrauch-Mettwurst, strei",
    "shop_url": "https://schinkendiele.de/products/prasent-im-schmuckkarton-natur-nr-35"
  },
  {
    "id": "prasent-im-schmuckkarton-grun-nr-34",
    "name": "Präsent im Schmuckkarton, grün, Nr. 34",
    "price": 105.0,
    "tags": [
      "Ammerland-Präsente",
      "Präsentkartons",
      "Schinken-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/34-Pr-sent-gr-n.jpg?v=1731353049",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "premium",
    "item_count": 37,
    "short_description": "Ein schöner Genusskorb zum Verschenken immer geeignet. Inhalt: Landschinken 500g Aalrauch-Bauern-Mettwurst 500g Aalrauchmettwurst, streichfähig, 250g Ammerländer-Mettwurst im Ring, 200g Bauern-Frühstü",
    "shop_url": "https://schinkendiele.de/products/prasent-im-schmuckkarton-grun-nr-34"
  },
  {
    "id": "schlemmerkorb-nr-5",
    "name": "Schlemmerkorb Nr. 5",
    "price": 143.0,
    "tags": [
      "Ammerland-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Praesentkorb_Nr_5_Schinkendiele.jpg?v=1749043429",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "premium",
    "item_count": 6,
    "short_description": "Geschenkset „Ammerländer Genusskorb“ – Traditionell, Herzhaft &amp; Hochwertig Dieses exklusive Präsent vereint eine feine Auswahl norddeutscher Spezialitäten aus handwerklicher Herstellung. Perfekt a",
    "shop_url": "https://schinkendiele.de/products/schlemmerkorb-nr-5"
  },
  {
    "id": "jubilaumskiepe-nr-55",
    "name": "Jubiläumskiepe Nr. 55",
    "price": 160.0,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente",
      "Sonstige",
      "Wein-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/55-neu-2020.jpg?v=1731352548",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "premium",
    "item_count": 81,
    "short_description": "Genussvolle Vielfalt aus Norddeutschland – Das Feinschmecker-Präsent in der Bauern-Kiepe Verschenken Sie puren Genuss mit dieser exquisiten Auswahl an herzhaften und süßen Spezialitäten. Liebevoll zus",
    "shop_url": "https://schinkendiele.de/products/jubilaumskiepe-nr-55"
  },
  {
    "id": "friesen-kiepe-nr-27",
    "name": "Friesen - Kiepe Nr. 27",
    "price": 166.0,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente",
      "Sonstige",
      "Wein"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Friesen_Kiepe_Nr_27_Schinkendiele.jpg?v=1731348127",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "premium",
    "item_count": 83,
    "short_description": "Genussvolle Vielfalt aus dem Norden – Ihr exklusives Feinschmecker-Paket Erleben Sie eine erlesene Auswahl feinster Spezialitäten, liebevoll zusammengestellt in einer traditionellen Kiepe. Dieses exkl",
    "shop_url": "https://schinkendiele.de/products/friesen-kiepe-nr-27"
  },
  {
    "id": "bauern-kiepe-nr-17",
    "name": "Bauern-Kiepe Nr. 17",
    "price": 175.0,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente",
      "Wein-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/17-Bauern_Kiepe.jpg?v=1731339386",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "premium",
    "item_count": 13,
    "short_description": "Ammerländer Delikatessen-Kiepe – Exklusive Spezialitäten aus Norddeutschland Ein hochwertiges Präsent für Genießer: Diese stilvolle Kiepe ist prall gefüllt mit handwerklich hergestellten Spezialitäten",
    "shop_url": "https://schinkendiele.de/products/bauern-kiepe-nr-17"
  },
  {
    "id": "ammerlander-spezialitaten-im-einkaufskorb-mit-textileinlage-nr-4",
    "name": "Ammerländer Spezialitäten im Einkaufskorb mit Textileinlage Nr. 4",
    "price": 218.0,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Ammerlander_Spezialitaetenkorb_Nr_4_Schinkendiele.jpg?v=1731339336",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "premium",
    "item_count": 8,
    "short_description": "Geschenkset „Ammerländer Spezialitäten“ – Herzhaft, Aromatisch &amp; Traditionell Dieses exklusive Präsent vereint eine feine Auswahl norddeutscher Spezialitäten aus handwerklicher Herstellung. Perfek",
    "shop_url": "https://schinkendiele.de/products/ammerlander-spezialitaten-im-einkaufskorb-mit-textileinlage-nr-4"
  },
  {
    "id": "gourmet-kiepe-nr-28",
    "name": "Gourmet - Kiepe Nr. 28",
    "price": 236.0,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/Gourmet_Kiepe_Nr_28_Schinkendiele.jpg?v=1731348153",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "premium",
    "item_count": 65,
    "short_description": "Die große Variante unseres Ammerländer Spezialitäten Geschenkkorbes hat alles zu bieten, was das Schlemmerherz begehrt – und noch mehr. Sei es der berühmte Ammerländer Knochenschinken und Katenschinke",
    "shop_url": "https://schinkendiele.de/products/gourmet-kiepe-nr-28"
  },
  {
    "id": "spezialitaten-kiepe-nr-18",
    "name": "Spezialitäten-Kiepe Nr. 18",
    "price": 270.0,
    "tags": [
      "Ammerland-Präsente",
      "Schinken-Präsente",
      "Sonstige"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0841/7964/8845/files/18-Kiepe.jpg?v=1731339411",
    "has_meat": true,
    "has_fish": false,
    "has_alcohol": true,
    "has_tea": false,
    "has_cheese": false,
    "is_vegetarian": false,
    "is_christmas": false,
    "is_kale": false,
    "size": "premium",
    "item_count": 11,
    "short_description": "Feinschmecker-Kiepe – Norddeutsche Delikatessen in stilvoller Präsentverpackung Erleben Sie die handwerkliche Tradition und den einzigartigen Geschmack Norddeutschlands in einer exklusiven Kiepe , gef",
    "shop_url": "https://schinkendiele.de/products/spezialitaten-kiepe-nr-18"
  }
];

/* Smart Suggestions (generated) */
window.KONFIG_TEMPLATES = [
  {
    "id": "klassiker",
    "name": "Ammerländer Klassiker",
    "emoji": "🏡",
    "subtitle": "Ausgewogen herzhaft & süß – der sichere Griff",
    "productIds": [
      "nuss-schinken-gerauchert",
      "luftgetrocknete-mettwurst-stuck-ca-600g",
      "akazienhonig",
      "ostfriesische-teestunde-schwarztee",
      "fleur-de-sel-truffel-100g"
    ],
    "price": 61.27,
    "suggestedBasket": "karton-3er"
  },
  {
    "id": "herzhaft",
    "name": "Herzhaft & Deftig",
    "emoji": "🍖",
    "subtitle": "Für Fleisch-Liebhaber – mit Abwechslung statt fünfmal Schinken",
    "productIds": [
      "nuss-schinken-gerauchert",
      "luftgetrocknete-mettwurst-stuck-ca-600g",
      "hausmacher-leberwurst-im-ring-ca-210g",
      "ganseschmaus-im-glas-125g",
      "tomatensosse-sommertruffel-350ml"
    ],
    "price": 63.24,
    "suggestedBasket": "karton-3er"
  },
  {
    "id": "teezeit",
    "name": "Teezeit & Süßes",
    "emoji": "🍵",
    "subtitle": "Ostfriesische Teekultur, Gebäck & Konfitüre – fleischfrei",
    "productIds": [
      "ostfriesische-teestunde-schwarztee",
      "fleur-de-sel-truffel-100g",
      "akazienhonig",
      "goldnusse-bonbons"
    ],
    "price": 18.65,
    "suggestedBasket": "korb-klein"
  },
  {
    "id": "festtag",
    "name": "Festtags-Präsent",
    "emoji": "✨",
    "subtitle": "Das große Rundum-Präsent – von herzhaft bis süß",
    "productIds": [
      "nuss-schinken-gerauchert",
      "luftgetrocknete-mettwurst-stuck-ca-600g",
      "ganseschmaus-im-glas-125g",
      "grobe-leberwurst-hausgemacht-200g-dose",
      "akazienhonig",
      "fleur-de-sel-truffel-100g",
      "ostfriesische-teestunde-schwarztee"
    ],
    "price": 71.17,
    "suggestedBasket": "kiepe-klein"
  },
  {
    "id": "gruss",
    "name": "Norddeutscher Gruß",
    "emoji": "🎁",
    "subtitle": "Kleines Mitbringsel – drei feine Spezialitäten",
    "productIds": [
      "nuss-schinken-gerauchert",
      "luftgetrocknete-mettwurst-stuck-ca-600g",
      "ostfriesische-teestunde-schwarztee"
    ],
    "price": 48.87,
    "suggestedBasket": "korb-klein"
  }
];
window.KONFIG_AFFINITY = {
  "Mettwurst": [
    "Schinken",
    "Tee",
    "Eingekochtes",
    "Aufstrich",
    "Gebäck & Süßes"
  ],
  "Schinken": [
    "Mettwurst",
    "Tee",
    "Eingekochtes",
    "Konfitüren & Honig",
    "Feinkost in Dosen"
  ],
  "Brot": [
    "Mettwurst",
    "Tee",
    "Schinken",
    "Konfitüren & Honig",
    "Aufstrich"
  ],
  "Gebäck & Süßes": [
    "Tee",
    "Konfitüren & Honig",
    "Sonstiges",
    "Mettwurst",
    "Schinken"
  ],
  "Konfitüren & Honig": [
    "Tee",
    "Gebäck & Süßes",
    "Sonstiges",
    "Mettwurst",
    "Schinken"
  ],
  "Salami": [
    "Eingekochtes",
    "Mettwurst",
    "Schinken",
    "Gebratenes & Fleisch",
    "Feinkost in Dosen"
  ],
  "Eingekochtes": [
    "Mettwurst",
    "Schinken",
    "Salami",
    "Tee",
    "Gebäck & Süßes"
  ],
  "Feinkost in Dosen": [
    "Schinken",
    "Mettwurst",
    "Eingekochtes",
    "Gebratenes & Fleisch",
    "Sonstiges"
  ],
  "Gebratenes & Fleisch": [
    "Mettwurst",
    "Salami",
    "Eingekochtes",
    "Feinkost in Dosen",
    "Schinken"
  ],
  "Tee": [
    "Gebäck & Süßes",
    "Konfitüren & Honig",
    "Mettwurst",
    "Sonstiges",
    "Schinken"
  ],
  "Aufstrich": [
    "Mettwurst",
    "Schinken",
    "Konfitüren & Honig",
    "Eingekochtes",
    "Tee"
  ],
  "Wein & Spirituosen": [
    "Gebäck & Süßes",
    "Feinkost in Dosen",
    "Gebratenes & Fleisch",
    "Tee"
  ],
  "Sonstiges": [
    "Tee",
    "Gebäck & Süßes",
    "Konfitüren & Honig",
    "Schinken",
    "Mettwurst"
  ],
  "Kaffee": [
    "Mettwurst",
    "Schinken",
    "Gebäck & Süßes",
    "Konfitüren & Honig",
    "Tee"
  ]
};
